{
  "common": {
    "appName": "atsume.camp",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "edit": "編集",
    "create": "作成",
    "search": "検索",
    "loading": "読み込み中…",
    "language": "言語"
  },
  "nav": {
    "dashboard": "ダッシュボード",
    "camps": "案件一覧",
    "partners": "パートナー",
    "timeline": "タイムライン",
    "inquiries": "受付",
    "forms": "フォーム",
    "settings": "設定",
    "admin": "Admin"
  },
  "camps": {
    "title": "案件一覧",
    "new": "新規案件",
    "searchPlaceholder": "検索...",
    "filterAll": "全て",
    "selectedCount": "{{count}}件選択中",
    "changeStatus": "ステータス変更",
    "clearSelection": "選択解除",
    "emptyFiltered": "該当する案件がありません",
    "datesTbd": "未定",
    "cols": {
      "status": "ステータス",
      "name": "案件名",
      "client": "クライアント",
      "destination": "行先",
      "dates": "日程",
      "pax": "参加者",
      "budget": "予算",
      "progress": "進捗"
    },
    "destination": "行き先",
    "startDate": "開始日",
    "endDate": "終了日",
    "pax": "参加人数",
    "empty": "ツアーがまだありません。最初のツアーを作成しましょう。",
    "status": {
      "inquiry": "問い合わせあり",
      "negotiating": "具体商談中",
      "likely": "実施濃厚",
      "confirmed": "確定・旅前",
      "active": "旅中",
      "settling": "ツアー完了（精算中）",
      "settled": "精算完了・最終確認",
      "completed": "完了"
    },
    "deleteConfirm": "{{count}}件の案件を削除しますか？この操作は取り消せません。",
    "countItems": "{{count}}件",
    "destinationTbd": "行先未定",
    "paxCount": "{{count}}名"
  },
  "campCreate": {
    "title": "新規案件を作成",
    "description": "AIにプロンプトを入力するか、手動でフォームに入力してください。",
    "aiMode": "AIモード",
    "manualMode": "手動入力",
    "promptLabel": "プロンプト",
    "promptPlaceholder": "例: オーストラリアのサッカーチーム40人が東京に1週間来たい。試合2試合+文化体験+チームビルディング。予算は1人45万円くらい",
    "aiNote": "※ AI生成は近日公開。現在はキーワード抽出で作成します",
    "creating": "作成中...",
    "createByKeyword": "キーワードで作成",
    "nameLabel": "案件名",
    "namePlaceholder": "例: 豪州サッカーチーム 東京遠征",
    "clientName": "クライアント名",
    "clientOrg": "クライアント組織",
    "destinationLabel": "行き先",
    "destinationPlaceholder": "例: 東京・横浜",
    "startDate": "開始日",
    "endDate": "終了日",
    "budgetLabel": "予算",
    "pax": {
      "adult": "大人",
      "adult2": "大人②",
      "child": "子供",
      "infant": "幼児",
      "other": "その他"
    },
    "tenantNotSelected": "テナントが選択されていません",
    "aiFailed": "AI生成に失敗しました。ローカルパースで作成しました。",
    "errors": {
      "nameRequired": "案件名は必須です",
      "nonNegative": "0以上の数値を入力してください"
    }
  },
  "dashboard": {
    "viewTableKpi": "テーブル · KPI",
    "viewKanban": "カンバン",
    "viewGantt": "ガント · エディトリアル",
    "tabUpcoming": "予定",
    "tabActive": "実施中",
    "tabCompleted": "終了済み",
    "searchPlaceholder": "案件を検索...",
    "selectPrompt": "案件を選択してください",
    "pipelineAndTimeline": "パイプライン・タイムライン",
    "campMenu": "「{{name}}」のメニュー",
    "deleteCampTitle": "この案件を削除しますか？",
    "deleteCampBody": "「{{name}}」を削除します。参加者・旅程・タスクなど、この案件のデータもすべて消え、元に戻せません。",
    "duplicate": "複製",
    "progress": "進捗",
    "nightsDays": "{{nights}}泊{{days}}日",
    "countCamps": "{{count}}件の案件",
    "viewOverview": "概要",
    "viewPipeline": "パイプライン",
    "viewSeason": "シーズン",
    "inFlight": "進行中",
    "pipelineValue": "パイプライン金額",
    "confirmedPax": "確定人数",
    "avgProgress": "平均進捗",
    "atRisk": "要注意",
    "pipeline": "パイプライン",
    "inFlightAmount": "{{amount}} が進行中",
    "thisSeason": "今シーズン",
    "pax": "人数"
  },
  "settings": {
    "profile": "プロフィール",
    "emailAddress": "メールアドレス",
    "displayName": "表示名",
    "notSet": "未設定",
    "tenant": "テナント",
    "tenantNameLabel": "テナント名（サイドバー左上に表示）",
    "tenantNamePlaceholder": "株式会社○○",
    "logoImageLabel": "ロゴ画像（正方形推奨、PNG / JPG / WebP / SVG、最大 2MB）",
    "changeImage": "画像を変更",
    "uploadImage": "画像をアップロード",
    "removeImage": "画像を削除",
    "closeUrlInput": "URL 入力を閉じる",
    "specifyByUrl": "URL で指定する（外部画像）",
    "savedConfirmation": "保存しました ✓",
    "theme": "テーマ",
    "darkMode": "ダークモード",
    "darkModeEnabled": "ダークモードが有効です",
    "lightModeEnabled": "ライトモードが有効です",
    "notifications": "通知設定",
    "emailNotifications": "メール通知",
    "emailNotificationsDesc": "案件の更新やリマインダーをメールで受信",
    "appInfo": "アプリ情報",
    "version": "バージョン",
    "environment": "環境",
    "support": "サポート",
    "errorSelectImageFile": "画像ファイルを選択してください",
    "errorFileSizeLimit": "ファイルサイズは 2MB 以下にしてください",
    "errorUploadFailed": "アップロードに失敗しました: {{message}}",
    "errorTenantNameRequired": "テナント名は必須です"
  },
  "inquiries": {
    "title": "受付（お問い合わせ）",
    "subtitle": "公開フォームからの問い合わせを確認し、日付別の研修 / TOUR に転換できます。",
    "filter": {
      "status": "ステータス",
      "kind": "希望",
      "all": "すべて"
    },
    "status": {
      "new": "新規",
      "contacted": "連絡済",
      "proposing": "提案中",
      "converted": "転換済",
      "declined": "見送り"
    },
    "kind": {
      "training": "研修",
      "tour": "ツアー",
      "retreat": "リトリート",
      "other": "その他",
      "undecided": "未定"
    },
    "empty": "該当する受付がありません",
    "table": {
      "receivedAt": "受付日時",
      "nameCompany": "お名前 / 会社",
      "contact": "連絡先",
      "dateHeadcount": "時期 / 人数",
      "source": "経路",
      "actions": "操作"
    },
    "headcountUnit": "{{count}} 名",
    "convert": "転換",
    "dialog": {
      "title": "研修 / TOUR に転換",
      "description": "この受付から日付別の案件（camp）を作成します。同じ受付から複数回（別日程）作成できます。",
      "created": "案件を作成しました。",
      "formUrl": "申込フォーム URL",
      "copy": "コピー",
      "noForm": "申込フォームは作成していません（必要に応じてフォーム画面から発行できます）。",
      "openCamp": "案件を開く",
      "done": "完了",
      "campName": "案件名",
      "kind": "種別",
      "headcount": "人数",
      "startDate": "開始日",
      "endDate": "終了日",
      "makeForm": "申込フォームも発行する（/f/… の公開URLを生成）",
      "submit": "転換する"
    }
  },
  "campEdit": {
    "title": "案件を編集",
    "description": "案件情報を更新してください。",
    "infoUrlLabel": "企画ページ URL（任意）",
    "infoUrlNote": "公開フォームのファーストビュー右上に「企画について」リンクとして表示されます。",
    "update": "更新",
    "errors": {
      "invalidUrl": "http:// または https:// で始まる URL を入力してください"
    }
  },
  "quote": {
    "title": "見積もり",
    "versionPlaceholder": "バージョン選択",
    "addItem": "明細追加",
    "importCsv": "CSVインポート",
    "importPdf": "PDF取込",
    "exportCsv": "CSV出力",
    "exportFilename": "見積もり_v{{version}}.csv",
    "compare": "見積もり比較",
    "compareDisabledHint": "比較するには2つ以上の見積もりが必要です",
    "createdAtLabel": "作成日",
    "colCategory": "カテゴリ",
    "colTarget": "対象",
    "colDescription": "内容",
    "colUnitPrice": "単価",
    "colQuantity": "数量",
    "colSubtotal": "小計",
    "colPartner": "パートナー",
    "total": "合計",
    "perPersonOverall": "一人あたり（全{{count}}名）",
    "perPersonUnit": "/名",
    "partnerBreakdown": "パートナー別内訳",
    "headcountSimulation": "人数シミュレーション",
    "currentHeadcountLabel": "現在の人数",
    "paxAdult": "大人{{count}}名",
    "paxAdult2": "大人②{{count}}名",
    "paxChild": "子供{{count}}名",
    "paxInfant": "幼児{{count}}名",
    "paxOther": "その他{{count}}名",
    "paxTotalSuffix": "（計{{count}}名）",
    "allSharedInfo": "すべての費用が共通費用のため、人数変更は合計に影響しません。明細の「対象」を設定すると人数連動の計算が可能になります。",
    "originalTotal": "元の合計",
    "sharedCost": "共通費用",
    "simLineAdult": "大人 x {{count}}名",
    "simLineAdult2": "大人② x {{count}}名",
    "simLineChild": "子供 x {{count}}名",
    "simLineInfant": "幼児 x {{count}}名",
    "simLineOther": "その他 x {{count}}名",
    "capacityBreakdownTitle": "人数に応じて数が変わる項目",
    "capacityLine": "{{description}}：{{from}}→{{to}}（{{unit}}名/単位）",
    "simulatedTotal": "シミュレーション合計（{{count}}名）",
    "difference": "差額",
    "perPerson": "一人あたり",
    "emptyItems": "見積もり項目がありません",
    "selfCompany": "自社",
    "unknownPartner": "不明",
    "category": {
      "accommodation": "宿泊",
      "transport": "交通",
      "content": "コンテンツ",
      "meal": "食事",
      "pmFee": "PM費用",
      "coachFee": "コーチ費",
      "other": "その他",
      "pm_fee": "PM費用",
      "coach_fee": "コーチ費"
    },
    "participant": {
      "common": "共通",
      "adult": "大人",
      "adult2": "大人②",
      "child": "子供",
      "infant": "幼児",
      "other": "その他"
    },
    "status": {
      "draft": "下書き",
      "sent": "送付済み",
      "approved": "承認済み"
    }
  },
  "participant": {
    "missingBadge": "未入力 {{count}}項目",
    "title": "参加者",
    "add": "参加者追加",
    "importCsv": "CSVインポート",
    "importPdf": "PDF取込",
    "exportCsv": "CSVエクスポート",
    "exportFilename": "参加者一覧.csv",
    "countPax": "{{count}}名",
    "total": "計",
    "funnel": "参加者ファネル",
    "dropOff": "{{count}}名 未進行",
    "searchPlaceholder": "名前またはメールで検索...",
    "all": "すべて",
    "selectedCount": "{{count}}名選択中",
    "selectStatus": "ステータス選択",
    "apply": "適用",
    "clearSelection": "選択解除",
    "empty": "該当する参加者がいません",
    "grandTotal": "総額（{{count}}名）",
    "basePrice": "基本料金",
    "optionCount": "（＋オプション{{count}}）",
    "status": {
      "interested": "興味あり",
      "registered": "申込済み",
      "paid_deposit": "入金済み",
      "confirmed": "確定"
    },
    "payment": {
      "paid": "支払済",
      "deposit": "デポジット済",
      "unpaid": "未払い"
    },
    "field": {
      "name": "名前",
      "role": "役割",
      "type": "種別",
      "age": "年齢",
      "status": "ステータス",
      "email": "メール",
      "payment": "支払い",
      "price": "料金",
      "allergies": "アレルギー",
      "passport": "パスポート",
      "flight": "到着便"
    },
    "staff": "運営"
  },
  "expense": {
    "tabEstimates": "概算",
    "tabActuals": "実績",
    "tabVariance": "差分",
    "csvImport": "CSV取込",
    "imageImport": "画像取込",
    "addEstimate": "概算追加",
    "addActual": "実績追加",
    "total": "合計",
    "cogs": "原価",
    "opex": "経費",
    "colCategory": "カテゴリ",
    "colCostType": "原価/経費",
    "colDescription": "内容",
    "colAmount": "金額",
    "colPartner": "パートナー",
    "colNote": "メモ",
    "colVendor": "支払先",
    "colPaidDate": "支払日",
    "colReceiptRef": "領収書番号",
    "colReceipt": "領収書",
    "colEstimate": "概算",
    "colActual": "実績",
    "colDiff": "差額",
    "noEstimates": "概算データがありません",
    "noActuals": "実績データがありません",
    "noVariance": "比較データがありません",
    "openReceipt": "領収書を開く",
    "receiptOpenFailed": "領収書を開けませんでした。もう一度押してください。",
    "receiptAlt": "領収書",
    "category": {
      "accommodation": "宿泊",
      "transport": "交通",
      "content": "コンテンツ",
      "meal": "食事",
      "pmFee": "PM費用",
      "coachFee": "コーチ費",
      "labor": "人件費",
      "other": "その他",
      "pm_fee": "PM費用",
      "coach_fee": "コーチ費"
    },
    "csvNoColumns": "CSVのヘッダーに「内容」「金額」に相当する列が見つかりません。\n対応ヘッダー例: 内容,金額 / 項目,費用 / description,amount",
    "csvImportSuccess": "{{count}}件の概算を取り込みました",
    "csvImportFailed": "取り込みに失敗しました: {{message}}",
    "csvNoImportableData": "取り込めるデータがありませんでした。\n\nデバッグ情報:\nヘッダー: {{header}}\n説明列({{descIdx}}): \"{{debugDesc}}\"\n金額列({{amtIdx}}): \"{{debugAmt}}\" → {{parsedAmt}}\n\n条件: 説明が空でない AND 金額 > 0",
    "colAmountKind": "実費/上限",
    "kindUndecided": "未確定",
    "kind": {
      "actual": "実費",
      "cap": "上限"
    },
    "amountKindFor": "{{name}} の実費/上限",
    "issues": "まだ握れていない原価: 金額未入力 {{missing}}件・上限のまま {{cap}}件・実費か上限か未確定 {{undecided}}件",
    "reimbursementTitle": "立替の精算（これから返すもの）",
    "reimbursementRow": "{{name}}: {{amount}}（{{count}}件）",
    "reimbursementNoName": "名前なし",
    "reimbursementTotal": "合計 {{amount}}",
    "reimbursementUnknown": "立替か精算済みか確認中: {{count}}件・{{amount}}"
  },
  "itinerary": {
    "title": "旅程",
    "addDay": "Day追加",
    "importCsv": "CSVインポート",
    "importPdf": "PDF取込",
    "exportCsv": "CSV出力",
    "exportFileName": "旅程.csv",
    "aiEdit": "AIで旅程を編集",
    "themePlaceholder": "テーマ（例: 大阪観光）",
    "copyToNextDay": "翌日にコピー",
    "addActivity": "アクティビティ追加",
    "noActivities": "このDayにはまだアクティビティがありません",
    "notConfigured": "旅程がまだ設定されていません",
    "generateFromAiSummary": "AIサマリーから旅程を生成",
    "deleteDayConfirm": "Day {{day}}を削除しますか？",
    "deleteDayWithActivitiesConfirm": "Day {{day}}（アクティビティ{{count}}件を含む）を削除しますか？",
    "activityType": {
      "transport": "交通",
      "accommodation": "宿泊",
      "content": "コンテンツ",
      "meal": "食事",
      "free": "自由時間"
    },
    "transportSubtype": {
      "flight": "フライト",
      "bus": "バス",
      "train": "電車",
      "taxi": "タクシー",
      "other": "その他"
    },
    "previewColumn": {
      "content": "内容",
      "type": "種別",
      "startTime": "開始時間",
      "day": "日目",
      "scheduleType": "日程"
    },
    "lane": {
      "content": "コンテンツ",
      "bus": "バス",
      "transport": "交通",
      "accommodation": "宿泊",
      "meal": "食事",
      "other": "その他"
    },
    "viewMode": {
      "day": "1日ずつ",
      "all": "全日まとめて",
      "grid": "時間グリッド"
    },
    "grid": {
      "untimed": "時間未定",
      "empty": "（未定）",
      "slotMinutes": "刻み",
      "minutesShort": "{{n}}分",
      "countSuffix": "計 {{n}}件",
      "coverage": "カバレッジ",
      "coverageHint": "塗りがある日は予定が入っています。空いているマスは抜けかもしれません。",
      "addHere": "ここに追加",
      "openDay": "この日を1日ずつ表示で開く"
    },
    "tbd": "仮",
    "tbdHint": "時間は仮置きです",
    "timeUnset": "時間未設定",
    "timeUnsetHint": "開始時刻が入っていない予定です。PDFでは時間が空欄になります。"
  },
  "applicant": {
    "title": "申込者",
    "subtitle": "フォーム経由 / 手動追加された申込を集約し、採用判断後に参加者へ昇格します。",
    "addManual": "手動で追加",
    "addManualDisabledHint": "先に申込フォームを発行してください",
    "filter": {
      "all": "すべて"
    },
    "review": {
      "pending": "未選考",
      "approved": "採用済",
      "rejected": "不採用",
      "auto_linked": "自動登録"
    },
    "empty": {
      "none": "まだ申込はありません。フォーム公開 or 手動追加で申込を集めてください。",
      "noMatch": "このフィルタに該当する申込はありません"
    },
    "goToFormsTab": "申込フォームタブへ",
    "noName": "(名前未入力)",
    "badge": {
      "manual": "手動追加",
      "duplicate": "重複候補"
    },
    "formLabel": "フォーム: {{label}}",
    "action": {
      "approve": "採用",
      "reject": "不採用"
    },
    "viewDetails": "詳細を見る",
    "confirm": {
      "approve": "この申込者を採用して参加者リストに加えますか？",
      "reject": "この申込者を不採用にしますか？",
      "delete": "この申込を完全に削除しますか？取り消せません。"
    },
    "error": {
      "nameRequired": "名前は必須です"
    },
    "manualDialog": {
      "title": "申込者を手動で追加",
      "description": "電話・対面で受け取った申込をシステムに登録します。",
      "instanceLabel": "どのフォームへの申込として記録",
      "instancePlaceholder": "フォームを選択",
      "submit": "追加"
    },
    "field": {
      "name": "氏名",
      "namePlaceholder": "山田 太郎",
      "emailOptional": "メール（任意）",
      "phoneOptional": "電話（任意）",
      "noteOptional": "メモ（任意）",
      "notePlaceholder": "どこで聞いた / 申込経緯など"
    }
  },
  "task": {
    "title": "タスク",
    "add": "タスク追加",
    "arrangementProgress": "手配進捗",
    "searchPlaceholder": "タスクを検索...",
    "selectedCount": "{{count}}件選択中",
    "bulkStatusChange": "ステータス一括変更",
    "clearSelection": "選択解除",
    "selectAll": "すべて選択",
    "selectRow": "{{description}}を選択",
    "emptyNoItinerary": "旅程を追加すると、自動でタスクが生成されます",
    "emptyNoMatch": "条件に一致するタスクがありません",
    "status": {
      "label": "ステータス",
      "all": "すべて",
      "todo": "未着手",
      "inProgress": "手配中",
      "review": "確認中",
      "done": "手配済み"
    },
    "column": {
      "date": "日付",
      "time": "時間",
      "type": "種別",
      "description": "内容",
      "partner": "パートナー",
      "arrangementStatus": "手配ステータス",
      "note": "備考",
      "day": "Day",
      "assignee": "担当者"
    },
    "activityType": {
      "transport": "移動",
      "accommodation": "宿泊",
      "content": "コンテンツ",
      "meal": "食事",
      "free": "自由行動"
    },
    "unassigned": "未定",
    "digestButton": "毎日Slackへ送る"
  },
  "login": {
    "heroLine1": "集まる時間を、",
    "heroHighlight": "最高の体験",
    "heroLine2Suffix": "に。",
    "categoryRetreat": "合宿",
    "categoryTraining": "研修",
    "categoryTour": "ツアー",
    "aboutLine1": "団体旅行・合宿・研修を運営するチームのための",
    "aboutLine2": "案件管理 SaaS — AI が見積もり下書きと要約を担う",
    "feature1": "粗利と自社負担を1 画面で",
    "feature2": "公開フォームで参加者集計を自動化",
    "feature3": "複数ブランドを1 アカウントで横断管理",
    "sentTitle": "メールを送信しました",
    "sentBody": "にログインリンクを送りました",
    "sentSpamHint": "メールが届かない場合は迷惑メールをご確認ください",
    "useDifferentEmail": "別のメールアドレスで再送信",
    "atsumeIdButton": "Camp ID でログイン",
    "divider": "または",
    "emailLabel": "メールアドレス",
    "magicLinkButton": "マジックリンクを送信",
    "contactSubject": "atsume.camp について",
    "contactBody": "お問い合わせ内容:\n\n組織名:\n想定利用人数:\n運営している案件のジャンル (合宿 / 研修 / ツアー など):\n\n----\natsume.camp チーム宛",
    "contactLink": "お問い合わせ",
    "brochureSubject": "atsume.camp 資料請求",
    "brochureBody": "資料請求:\n\n組織名:\n部署 / 役職:\n想定利用人数:\n検討中の案件タイプ:\n\n----\natsume.camp チーム宛",
    "brochureLink": "資料請求"
  },
  "publicInquiry": {
    "notFound": "お問い合わせ先が見つかりません。URL をご確認ください。",
    "validation": {
      "nameRequired": "お名前をご入力ください。",
      "contactRequired": "メールアドレスまたは電話番号のいずれかをご入力ください。"
    },
    "eyebrow": "─ Inquiry ／ お問い合わせ",
    "introLine1": "研修・ツアー・リトリートのご相談を受け付けています。",
    "introLine2": "内容を確認のうえ、担当より折り返しご連絡いたします。",
    "field": {
      "company": "会社名 / 団体名",
      "name": "お名前",
      "email": "メールアドレス",
      "phone": "電話番号",
      "desiredKind": "ご希望の内容",
      "desiredDates": "ご希望時期",
      "headcount": "想定人数",
      "message": "ご相談内容"
    },
    "placeholder": {
      "company": "株式会社〇〇",
      "desiredDates": "例：来月後半 / 2026年7月ごろ",
      "headcount": "例：20",
      "message": "ご相談・ご質問などをご記入ください。"
    },
    "submitting": "送信中",
    "submit": "送信する"
  },
  "publicForm": {
    "notFound": "フォームが見つかりません。URL をご確認ください。",
    "notPublished": "このフォームは現在公開されていません。",
    "closed": "このフォームは受付を終了しました。",
    "archived": "このフォームは利用できません。",
    "apply": "Apply",
    "entry": "Entry",
    "selectPlaceholder": "選択してください",
    "yes": "はい",
    "submit": "応募する",
    "submitting": "送信中",
    "selectionNote": "※ 少人数のため、内容により選考とさせていただく場合があります",
    "fallbackOpenError": "フォームを開けません",
    "host": "Host",
    "invitationEyebrow": "─ Application ／ 申し込みフォーム",
    "aboutLink": "企画について",
    "preEvent": {
      "apply": "事前フォーム",
      "entry": "事前フォーム",
      "submit": "回答する",
      "invitationEyebrow": "─ 事前フォーム"
    },
    "switchToEnglish": "Switch to English",
    "switchToJapanese": "日本語に切替"
  },
  "admin": {
    "refresh": "更新",
    "change": "変更",
    "forceResolveStuck": "詰まり{{count}}件を強制解消",
    "sessionsTitle": "System Updates — パイプラインセッション",
    "requestsTitle": "System Updates — リクエスト一覧",
    "noSessions": "セッションなし",
    "noRequests": "リクエストなし",
    "kpi": {
      "open": "オープン",
      "inProgress": "対応中",
      "activeSessions": "アクティブセッション",
      "stuck": "詰まり"
    },
    "col": {
      "status": "ステータス",
      "description": "説明",
      "proposal": "提案",
      "github": "GitHub",
      "updated": "更新",
      "actions": "操作",
      "category": "カテゴリ",
      "message": "メッセージ",
      "user": "ユーザー",
      "datetime": "日時"
    },
    "requestStatus": {
      "open": "オープン",
      "in_progress": "対応中",
      "done": "完了",
      "dismissed": "却下"
    },
    "sessionStatus": {
      "clarifying": "質問中",
      "proposed": "提案済",
      "approved": "承認済",
      "running": "実行中",
      "success": "成功",
      "failed": "失敗",
      "cancelled": "キャンセル"
    },
    "category": {
      "bug": "バグ",
      "feature": "機能",
      "improvement": "改善",
      "task": "タスク",
      "other": "その他"
    },
    "elapsed": {
      "minutesAgo": "{{count}}分前",
      "hoursAgo": "{{count}}時間前",
      "daysAgo": "{{count}}日前"
    }
  },
  "formResponses": {
    "status": {
      "pending": "未選考",
      "approved": "採用",
      "rejected": "不採用",
      "autoLinked": "自動登録"
    },
    "boolean": {
      "yes": "はい",
      "no": "いいえ"
    },
    "csv": {
      "submittedAt": "送信日時",
      "status": "ステータス",
      "fileSuffix": "回答"
    },
    "confirmReject": "この応募を不採用にします。よろしいですか？",
    "notFound": "見つかりません",
    "back": "← 戻る",
    "backShort": "戻る",
    "downloadCsv": "CSV ダウンロード",
    "responseCount": "回答数",
    "mode": "モード",
    "linkMode": {
      "auto": "直接登録",
      "selection": "選考制（採用判断要）",
      "none": "アンケート",
      "preEvent": "参加者事前回答"
    },
    "empty": "まだ回答がありません",
    "table": {
      "submittedAt": "送信日時",
      "status": "状態",
      "actions": "アクション"
    },
    "duplicate": "重複",
    "duplicateTitle": "同じメール+名前の応募があります",
    "approve": "採用",
    "reject": "不採用",
    "dialog": {
      "title": "応募を採用 → 参加者に登録",
      "description": "この内容で participants に新しい行を作成します。後から編集も可能です。",
      "name": "氏名",
      "email": "メール",
      "phone": "電話 (任意)",
      "status": "ステータス",
      "type": "種別",
      "submit": "採用して登録"
    },
    "participantStatus": {
      "interested": "興味あり",
      "registered": "登録済",
      "paidDeposit": "内金支払済",
      "confirmed": "確定"
    },
    "participantType": {
      "adult": "大人",
      "child": "子供"
    }
  },
  "formInstances": {
    "status": {
      "draft": "下書き",
      "published": "公開中",
      "closed": "受付終了"
    },
    "error": {
      "selectCamp": "紐付ける案件を選択してください",
      "invalidEmail": "不正なメール形式: {{email}}",
      "invalidSlug": "スラッグは英小文字・数字・ハイフンのみ、先頭末尾は英数字",
      "missingLinkageFields": "このモードで発行するには、テンプレートに {{fields}} フィールドが必要です。テンプレートを編集するか「連携なし」モードを選んでください。",
      "fieldJoiner": " と "
    },
    "confirm": {
      "delete": "この公開URLを削除しますか？回答も削除されます。"
    },
    "templateNotFound": "テンプレートが見つかりません",
    "backToList": "← 一覧に戻る",
    "backToEdit": "編集に戻る",
    "publishDistribute": "公開・配布",
    "subtitle": "案件に紐付けて公開URLを発行します。回答は管理画面で確認できます。",
    "createHeading": "新規公開URLを発行",
    "linkedCamp": "紐付け案件",
    "selectCampPlaceholder": "案件を選択...",
    "noCamps": "案件がありません。先に案件を作成してください。",
    "slugLabel": "URL スラッグ (任意)",
    "slugHelpPrefix": "公開URLが",
    "slugHelpSuffix": "になります",
    "linkModeLabel": "応募処理モード",
    "notifyLabel": "通知メール (回答時に送信、任意)",
    "notifyHelp": "カンマかスペースで複数指定可能。空欄なら通知なし。",
    "createButton": "公開URL発行",
    "publishedHeading": "発行済みURL ({{count}})",
    "noneIssued": "まだ発行されていません",
    "badge": {
      "auto": "直接登録",
      "selection": "選考制",
      "none": "アンケート",
      "preEvent": "参加者事前回答"
    },
    "notifyCount": "通知 {{count}}件",
    "aria": {
      "viewResponses": "回答を見る",
      "copyUrl": "URLをコピー",
      "preview": "プレビュー",
      "settings": "設定"
    },
    "copied": "コピーしました"
  },
  "campOverview": {
    "paymentType": {
      "deposit": "デポジット支払い",
      "interim": "中間金支払い",
      "final": "残額支払い"
    },
    "noteType": {
      "meetingNote": "議事録",
      "decision": "決定事項",
      "todo": "TODO",
      "default": "メモ"
    },
    "partnerType": {
      "travelAgency": "旅行手配",
      "contentProvider": "コンテンツ",
      "coach": "コーチ"
    },
    "tbd": "未定",
    "dueInDays": "期限: {{date}}（{{count}}日後）",
    "followUpUnconfirmed": "未確定の参加者 {{count}}名のフォローアップ",
    "changeNotesCount": "このツアーには変更メモが {{count}} 件あります",
    "changeNotesLatest": "直近: {{content}}",
    "changeNotesHint": "料金や条件の変更履歴は「収益管理 → 入金管理」タブで確認できます。",
    "overallProgress": "全体進捗",
    "untilDeparture": "出発まで",
    "daysValue": "{{count}}日",
    "today": "本日",
    "schedule": "日程",
    "nightsDays": "{{nights}}泊{{days}}日",
    "participants": "参加者",
    "paxCount": "{{count}}名",
    "paxBreakdown": "大人{{adult}} / 子供{{child}}",
    "budget": "予算",
    "budgetUsed": "{{percent}}%消化",
    "nextActions": "次のアクション",
    "noActions": "現時点でのアクションはありません",
    "collapse": "折りたたむ",
    "showMore": "他{{count}}件を表示",
    "partners": "パートナー",
    "role": "役割",
    "contact": "担当",
    "aiSummary": "AIサマリー",
    "updatedAt": "更新: {{date}}",
    "generateFromSummary": "AIサマリーから旅程を生成",
    "aiSummaryRequired": "AIサマリーが必要です",
    "generateItineraryFromSummary": "サマリーから旅程を生成",
    "aiSummaryEmpty": "AIサマリーはまだ生成されていません。データが蓄積されると自動的に更新されます。",
    "recentActivity": "最近のアクティビティ",
    "activity": {
      "taskDone": "タスク「{{title}}」を完了",
      "taskStarted": "タスク「{{title}}」を開始",
      "taskCreated": "タスク「{{title}}」を作成",
      "noteAdded": "{{type}}「{{title}}」を追加",
      "paymentConfirmed": "{{type}} ¥{{amount}} 入金確認"
    }
  },
  "campForms": {
    "errors": {
      "selectTemplate": "テンプレートを選択してください",
      "missingFields": "このモードで発行するには、テンプレートに {{fields}} フィールドが必要です。",
      "fieldsConjunction": " と ",
      "invalidEmail": "不正なメール形式: {{email}}",
      "invalidSlug": "スラッグは英小文字・数字・ハイフンのみ、先頭末尾は英数字"
    },
    "newTemplateName": "{{campName}} 応募フォーム",
    "confirmDelete": "この公開URLを削除しますか？回答も削除されます。",
    "title": "申込フォーム",
    "subtitle": "応募・参加者情報・アンケート等の公開フォームをこの案件向けに発行できます。",
    "issueNewUrl": "新規公開URLを発行",
    "newTemplate": "新規テンプレート",
    "noTemplates": "フォームテンプレートがまだありません。",
    "noTemplatesHint": "「新規テンプレート」ボタンからこの案件用のフォームを作成してください。",
    "templateLabel": "テンプレート",
    "templatePlaceholder": "テンプレートを選択...",
    "editTemplate": "テンプレートを編集",
    "slugLabel": "URL スラッグ (任意)",
    "slugHelpPrefix": "公開URLが",
    "slugHelpSuffix": "になります",
    "linkModeLabel": "応募処理モード",
    "notifyLabel": "通知メール (回答時に送信、任意)",
    "notifyHelp": "カンマかスペースで複数指定可能。空欄なら通知なし。",
    "issueUrlButton": "公開URL発行",
    "issuedUrls": "発行済みURL ({{count}})",
    "noInstances": "この案件にはまだフォームが発行されていません",
    "mode": {
      "auto": "直接登録",
      "selection": "選考制",
      "none": "アンケート",
      "preEvent": "参加者事前回答"
    },
    "notifyCount": "通知 {{count}}件",
    "viewResponses": "回答を見る",
    "copyUrl": "URLをコピー",
    "showQr": "QRコードを表示",
    "preview": "プレビュー",
    "settings": "設定",
    "copied": "コピーしました"
  },
  "itineraryGen": {
    "title": "AIで生成された旅程",
    "description": "AIサマリーから抽出された旅程を確認・編集してから旅程タブに反映します。",
    "errorEmptySummary": "AIサマリーが空です。先に概要を入力してください。",
    "errorNoExtract": "AIが旅程を抽出できませんでした。サマリーをもう少し具体的にして再生成してください。",
    "errorGenerateFailed": "生成に失敗しました",
    "existingDaysPrefix": "既に",
    "existingDaysCount": "{{count}} 日分",
    "existingDaysSuffix": "の旅程があります",
    "modeAppend": "追加",
    "modeReplace": "置換（既存を削除）",
    "editPromptToggle": "プロンプトを編集して再生成",
    "retry": "もう一度試す",
    "overrideLabel": "AIへの追加指示（例: 各日のテーマをもっと簡潔に / 食事を3食に分けて）",
    "overridePlaceholder": "追加で指示したい内容を入力...",
    "regenerate": "再生成",
    "generating": "生成中... 通常 5-10 秒",
    "themePlaceholder": "テーマ",
    "noActivities": "アクティビティなし",
    "confirmReplace": "既存の旅程 {{count}} 日分は完全に削除されます。よろしいですか？",
    "countSummary": "{{days}} 日 · {{count}} 件のアクティビティ",
    "applyReplaceConfirm": "{{count}} 件で置換する",
    "applyReplace": "{{count}} 件で置換 →",
    "applyAppend": "{{count}} 件を追加 →",
    "editActivity": "編集",
    "removeActivity": "削除",
    "fieldTime": "時刻",
    "fieldType": "種別",
    "fieldDescription": "説明",
    "fieldNote": "補足メモ（任意）"
  },
  "partnersSection": {
    "title": "パートナー",
    "addPartner": "パートナー追加",
    "partnerType": {
      "travelAgency": "旅行会社",
      "contentProvider": "コンテンツ提供",
      "coach": "コーチ"
    },
    "taskStatus": {
      "todo": "ToDo",
      "inProgress": "進行中",
      "review": "レビュー",
      "done": "完了"
    },
    "responseStatus": {
      "noTasks": "タスクなし",
      "done": "完了",
      "inProgress": "対応中",
      "notStarted": "未着手"
    },
    "staleTitle": "最後にタスクを追加・更新してから{{count}}日。7日以上、未完了のまま動きがないパートナーに表示されます",
    "staleLabel": "({{count}}日 動きなし)",
    "contactPerson": "担当",
    "email": {
      "subject": "【atsume.camp】ご確認のお願い",
      "body": "{{recipient}}様\n\nいつもお世話になっております。\n{{topic}}ご確認いただきたい事項がございます。\n\n■ 確認事項\n・\n\n■ 期限\n・\n\nお手数をおかけしますが、ご確認の程よろしくお願いいたします。\n\n---\natsume.camp",
      "topicWithRole": "{{role}}について",
      "topicDefault": "案件について",
      "compose": "メール作成"
    },
    "assignedCategoriesLabel": "担当カテゴリ",
    "taskProgress": "タスク進捗",
    "taskCompletion": "{{completed}}/{{total}}完了",
    "noTasksAssigned": "割り当てられたタスクはありません",
    "emptyState": "パートナーはまだ割り当てられていません",
    "dialog": {
      "title": "パートナーを割り当て",
      "partnerLabel": "パートナー",
      "partnerPlaceholder": "パートナーを選択...",
      "roleLabel": "役割説明",
      "rolePlaceholder": "例: 宿泊手配担当",
      "categoriesLabel": "担当カテゴリ（カンマ区切り）",
      "categoriesPlaceholder": "例: 宿泊, 交通",
      "assign": "割り当て",
      "regionLabel": "地域で絞る",
      "regionPlaceholder": "地域",
      "allRegions": "すべての地域",
      "noPartnersInRegion": "この地域のパートナーはまだ登録されていません。"
    },
    "coachInvoice": {
      "none": "未案内",
      "sent": "案内済",
      "submitted": "提出済",
      "approved": "承認済",
      "updatedAt": "更新: {{date}}"
    }
  },
  "expenseEstimate": {
    "titleEdit": "経費概算を編集",
    "titleAdd": "経費概算を追加",
    "categoryLabel": "カテゴリ",
    "categoryPlaceholder": "カテゴリを選択",
    "indirectLabel": "経費として扱う（自社PM費・運営間接費）",
    "segmentLabel": "区分",
    "segmentCommon": "共通原価（全員に按分）",
    "segmentAdult": "大人のみ",
    "segmentAdult2": "大人②のみ",
    "segmentChild": "子供のみ",
    "segmentInfant": "幼児のみ",
    "segmentOther": "その他のみ",
    "segmentHint": "ツアー料金の自動計算で、この原価をどの区分に紐づけるかを指定します。",
    "descriptionPlaceholder": "例: ホテル宿泊（大人30名×9泊）",
    "amountLabel": "金額（円）",
    "partnerPlaceholder": "パートナーを選択",
    "partnerNone": "なし",
    "payerSectionLabel": "支払者・自社負担",
    "payerLabel": "支払者（立替）",
    "payerSelf": "自社払い",
    "selfBurdenLabel": "自社負担額（円）",
    "advanceHint": "立替額 {{amount}} は立替者の負担。自社負担額のみ PL の経費に計上。",
    "submitUpdate": "更新",
    "submitAdd": "追加",
    "errorCategoryRequired": "カテゴリを選択してください",
    "errorDescriptionRequired": "内容は必須です",
    "errorAmountMin": "0以上の数値を入力してください"
  },
  "activityDialog": {
    "typeRequired": "種別を選択してください",
    "descriptionRequired": "内容は必須です",
    "editTitle": "アクティビティを編集",
    "addTitle": "アクティビティを追加",
    "startTime": "開始時刻",
    "endTime": "終了時刻",
    "type": "種別",
    "typePlaceholder": "種別を選択",
    "transportMeans": "交通手段",
    "transportMeansPlaceholder": "交通手段を選択",
    "arrivalDate": "到着日",
    "description": "内容",
    "descriptionPlaceholder": "例: 成田空港到着・チャーターバスでホテルへ移動",
    "note": "メモ",
    "notePlaceholder": "補足情報",
    "partner": "パートナー",
    "partnerPlaceholder": "パートナーを選択",
    "partnerNone": "なし",
    "update": "更新",
    "add": "追加",
    "createTaskConfirm": "💡 「{{suggestion}}」タスクを作成しますか？",
    "taskSuggestion": {
      "accommodation": "ホテル予約確認",
      "transport": "交通手配確認",
      "content": "コンテンツ手配確認",
      "meal": "食事手配確認"
    },
    "timeTbd": "この時刻は仮",
    "timeTbdHint": "午前／午後でしか決まっていないときに使います。PDFでは時刻に「（仮）」が付きます。",
    "quickAm": "午前 9:00-12:00",
    "quickPm": "午後 13:00-18:00"
  },
  "participantDialog": {
    "editTitle": "参加者を編集",
    "addTitle": "参加者を追加",
    "field": {
      "type": "種別",
      "age": "年齢",
      "basePrice": "料金（一人あたり、円）",
      "phone": "電話",
      "passportNumber": "パスポート番号",
      "roomAssignment": "部屋割り",
      "allergies": "アレルギー",
      "givenNameRoman": "名（ローマ字）",
      "familyNameRoman": "姓（ローマ字）",
      "dateOfBirth": "生年月日",
      "gender": "性別",
      "nationality": "国籍",
      "passportExpiry": "パスポート有効期限",
      "arrivalFlight": "到着便",
      "arrivalAt": "到着日時",
      "arrivalAirport": "到着空港",
      "departureFlight": "出発便",
      "departureAt": "出発日時",
      "departureAirport": "出発空港",
      "note": "備考",
      "visaDocStatus": "ビザ書類"
    },
    "total": "合計",
    "add": "追加",
    "update": "更新",
    "options": {
      "label": "オプション（任意）",
      "add": "オプション追加"
    },
    "placeholder": {
      "role": "例: Head Coach",
      "basePrice": "例: 300000",
      "optionLabel": "例: 空港送迎",
      "optionAmount": "金額",
      "allergies": "例: Shellfish, Peanuts",
      "givenNameRoman": "Bimal",
      "familyNameRoman": "Wagle",
      "nationality": "Australia",
      "flight": "JL772",
      "airport": "KIX",
      "note": "入れ替え元・キャンセル理由など"
    },
    "validation": {
      "nameRequired": "名前は必須です",
      "emailInvalid": "有効なメールアドレスを入力してください"
    },
    "section": {
      "travel": "渡航情報",
      "travelHint": "パスポートのとおりに入れてください。保険の加入と航空券の手配に使われます。",
      "flight": "飛行機"
    },
    "gender": {
      "unset": "未選択",
      "male": "男性",
      "female": "女性",
      "other": "その他"
    },
    "visa": {
      "exempt": "この国籍は短期滞在のビザ免除対象です（参考。最終確認は代理店へ）",
      "conditional": "条件つきで免除になる国籍です。事前登録が要るか代理店に確認してください",
      "required": "ビザ申請が要る可能性があります。早めに代理店へ確認してください"
    },
    "visaDoc": {
      "unset": "未記入",
      "not_started": "未着手",
      "letter_issued": "招へい状 発行済",
      "applied": "申請中",
      "granted": "取得済",
      "not_needed": "不要と確認済"
    }
  },
  "revenueV2": {
    "title": "収益管理",
    "tabPl": "PL概要",
    "tabRevenue": "売上管理",
    "tabCogs": "原価管理",
    "tabOpex": "経費管理",
    "tabPayments": "入金管理",
    "metricRevenue": "売上",
    "metricCogs": "原価",
    "metricGrossProfit": "粗利",
    "metricOpex": "経費",
    "metricOperatingProfit": "営業利益",
    "unitEconomicsTitle": "一人あたりユニットエコノミクス",
    "paxBreakdown": "総人数 {{total}} 名 (大人{{adult}} / 大人②{{adult2}} / 子供{{child}} / 幼児{{infant}} / その他{{other}})",
    "unitPriceLabel": "単価（売上 ÷ 人数）",
    "perPaxCogs": "per-pax 原価",
    "perPaxGrossProfit": "per-pax 粗利",
    "plSummaryTitle": "損益サマリー（自社負担ベース）",
    "advanceNote": "※ 立替（パートナー負担）合計 {{amount}} は PL から除外。原価・経費は自社負担額のみで集計。",
    "paymentStatusTitle": "入金状況",
    "paidOverDue": "入金済み / 請求合計",
    "lossBadge": "赤字",
    "actualLabel": "実績",
    "displaySettings": "表示設定",
    "exportPdf": "PDF出力",
    "includeRelated": "関連ツアーを含める（PL概要と PDF が合算になります）",
    "showAud": "A$ を併記する",
    "combinedNote": "PL概要とPDFは {{names}} の合算です。売上・原価・経費・入金の各タブはこの案件だけを編集します。",
    "byCampTitle": "案件別",
    "byCampName": "案件",
    "byCampPax": "人数",
    "byCampTotal": "合計"
  },
  "cogsPricing": {
    "noPaxTitle": "⚠ 人数が未設定です",
    "noPaxDescription": "概要タブで参加者人数（大人・子供・幼児）を設定すると、原価から料金が自動計算されます。",
    "title": "原価ベースの料金自動計算",
    "noCogsTitle": "原価がまだ入力されていません",
    "noCogsDescription": "「原価管理」タブでホテル代・移動費などを入力すると、ここに区分別の料金が自動で出ます。",
    "colSegment": "区分",
    "colPax": "人数",
    "colUnitCost": "単価原価",
    "colUnitPrice": "単価料金",
    "colSubtotal": "小計",
    "individualBadge": "個別",
    "paxCount": "{{count}}名",
    "totalRevenueWithMargin": "合計売上（実効利益率 {{rate}}%）",
    "unallocatedWarning": "{{segments}}の固有原価がありますが人数が 0 のため料金に反映されません。",
    "profitSettingGlobal": "利益設定（全体）",
    "marginRate": "利益率",
    "profitAmount": "利益額",
    "marginRateHint": "% — 料金 = 原価 ÷ (1 − 利益率)",
    "profitAmountUnit": "円（ツアー全体の利益額）",
    "allocCostProportional": "原価比例で配分",
    "allocPerPax": "人数均等で配分",
    "perSegmentToggle": "区分ごとに変える（任意）",
    "overrideCount": "{{count}}件",
    "overrideGlobal": "全体に従う",
    "overrideMarginRate": "利益率（%）",
    "overrideProfitAmount": "利益額（円/人）",
    "savedBadge": "保存しました",
    "saveAndApply": "保存して売上に反映"
  },
  "plView": {
    "tabPl": "損益",
    "tabRevenue": "売上",
    "tabPayments": "入金管理",
    "taxChip": "税区分 未確定 {{count}}件",
    "flowLabel": "このツアーのお金の流れ",
    "flowVia": "パートナー経由あり（{{name}}）",
    "flowViaPick": "パートナー経由あり",
    "flowDirect": "直接だけ",
    "flowPartner": "精算するパートナー",
    "flowPartnerPick": "パートナーを選ぶ",
    "flowViaHint": "パートナーが払う費目は「精算書待ち」。パートナーからの精算額が自社への入金になります",
    "flowDirectHint": "お客様から自社に直接入り、自社が業者に払います",
    "kpiLandingCost": "着地見込み原価",
    "kpiLandingCostSub": "うち実績 {{actual}}",
    "kpiVariance": "予算差異（見込み）",
    "overBudget": "予算超過",
    "kpiVarianceSub": "予算原価 {{budget}}",
    "kpiReceived": "入金額",
    "kpiReceivedSub": "回収率 {{rate}}%（請求額 {{billed}}）",
    "kpiReceivedNone": "自社の口座に入った額",
    "kpiCash": "現金収支",
    "kpiCashSub": "入金額 − 自社が払った額",
    "budgetTitle": "予実管理",
    "importCsv": "CSV取込",
    "importImage": "画像取込",
    "addActual": "支払明細を追加",
    "addBudgetLine": "予算科目を追加",
    "taxBanner": "予算の {{count}} 件は税抜か税込かが決まっていません。決まるまで予算差異は参考値です。右上の「税区分」でまとめてそろえられます。",
    "hideZero": "予算も実績も ¥0 の行を隠す",
    "colLine": "費目",
    "colStatus": "状態",
    "colBudget": "予算",
    "colActual": "実績",
    "colLanding": "着地見込み",
    "colVariance": "予算差異（予算 − 見込み）",
    "colItem": "科目",
    "colPerPax": "一人あたり（見込み）",
    "secCogs": "売上原価",
    "secOpex": "販売費及び一般管理費",
    "groupPartner": "{{name}}が払う",
    "groupPartnerHint": "お客様がパートナーに払った代金からパートナーが支払い、残りを自社に精算",
    "groupCompany": "自社が払う",
    "groupCompanyHint": "自社から業者・コーチ・立替者に支払い",
    "boxCollected": "お客様 → {{name}} の入金",
    "boxPartnerCost": "パートナーの実費（精算書）",
    "boxSettlement": "{{name}} → 自社への精算額",
    "notEntered": "未入力",
    "awaitingStatement": "精算書待ち",
    "enterInPayments": "入金管理タブで入力 →",
    "enterPerLine": "費目を開いて精算書の金額を入力",
    "noOpex": "この案件の販管費（広告費・システム費など）はまだありません。",
    "total": "合計",
    "landingNote": "着地見込み ＝ 支払済・精算書で確定の費目は実績、まだの費目は予算と実績の大きい方。予算差異は予算を超えた行だけ赤くなります。",
    "taxQ": "税区分?",
    "provisional": "未確定 {{count}}件",
    "provisionalOne": "未確定",
    "status": {
      "unbilled": "未請求",
      "billed": "請求済",
      "paid": "支払済",
      "awaiting_statement": "精算書待ち",
      "settled": "精算書で確定"
    },
    "paidBy": "誰が払うか",
    "paidByCompany": "自社",
    "paidByPartner": "{{name}}（精算）",
    "editLine": "費目を編集",
    "actualsTitle": "支払明細 {{count}}件",
    "addStatementLine": "精算書の金額を入力",
    "noActuals": "まだありません。請求書が来たら「支払明細を追加」で入れます。",
    "noActualsPartner": "まだありません。パートナーの精算書が来たら、この費目の金額を「精算書の金額を入力」で入れます。",
    "advancedBy": "立替 {{name}}",
    "edit": "編集",
    "unassignedTitle": "予算未割当の支出",
    "unassignedSub": "{{count}}件・精算タブで費目を割り当てる →",
    "needsAssign": "要割当",
    "unassignedHint": "どの費目の分かを選んでください。立替の承認は「精算」タブで行います。",
    "assignTo": "費目を選ぶ",
    "combinedBudgetNote": "合算表示のときは案件ごとの予算で比べます。費目ごとの予実は案件を1つにして見てください。",
    "statementTitle": "損益計算書",
    "rowRevenue": "売上高",
    "rowCogs": "売上原価",
    "rowGross": "売上総利益（粗利）",
    "rowOpex": "販売費及び一般管理費",
    "rowOperating": "営業利益",
    "cashTitle": "お金の動き（今の時点・この案件）",
    "cashReceived": "自社への入金額",
    "cashPaid": "自社が払った額",
    "cashNet": "現金収支",
    "cashNotYet": "まだ入っていない・精算されていない額",
    "cashNotYetHint": "粗利（見込み）− 現金収支。全部精算されると 0 になります"
  },
  "expenseActual": {
    "estimateLabel": "予算科目",
    "estimateNone": "未割当（あとで選ぶ）",
    "editTitle": "実費を編集",
    "addTitle": "実費を追加",
    "categoryLabel": "カテゴリ",
    "categoryPlaceholder": "カテゴリを選択",
    "categoryRequired": "カテゴリを選択してください",
    "descriptionRequired": "内容は必須です",
    "amountMin": "0以上の数値を入力してください",
    "isIndirectLabel": "経費として扱う（自社PM費・運営間接費）",
    "descriptionPlaceholder": "例: 品川プリンスホテル 宿泊費",
    "partnerPlaceholder": "パートナーを選択",
    "partnerNone": "なし",
    "amountYenLabel": "金額（円）",
    "payerSelfBurdenTitle": "支払者・自社負担",
    "payerLabel": "支払者（立替）",
    "payerSelf": "自社払い",
    "selfBurdenAmountLabel": "自社負担額（円）",
    "advanceNote": "立替額 ¥{{amount}} は立替者の負担。自社負担額のみ PL に計上。",
    "receiptImageLabel": "領収書画像",
    "noteLabel": "メモ",
    "update": "更新",
    "add": "追加"
  },
  "quoteItem": {
    "editTitle": "見積明細を編集",
    "addTitle": "見積明細を追加",
    "categoryLabel": "カテゴリ",
    "categoryPlaceholder": "カテゴリを選択",
    "categoryRequired": "カテゴリを選択してください",
    "participantLabel": "対象区分",
    "participantPlaceholder": "対象区分を選択",
    "descriptionRequired": "内容は必須です",
    "descriptionPlaceholder": "例: 品川プリンスホテル ツイン20室×7泊",
    "unitPriceYen": "単価（円）",
    "subtotalYen": "小計（円）",
    "subtotalMin": "0以上の数値を入力してください",
    "partnerLabel": "パートナー",
    "partnerPlaceholder": "パートナーを選択",
    "partnerNone": "なし",
    "capacityUnitLabel": "1単位あたりの定員（任意）",
    "capacityUnitPlaceholder": "例: バス1台45名、部屋1室4名",
    "capacityUnitHelp": "バスや部屋のように、人数に応じて必要な数が変わる明細に設定します。設定すると人数シミュレーションで必要数が自動的に再計算されます。",
    "update": "更新",
    "add": "追加"
  },
  "campDetail": {
    "tabOverview": "概要",
    "tabNotes": "メモ",
    "tabRooming": "部屋割り",
    "tabDocuments": "書類",
    "sectionNav": "セクション",
    "moreSections": "その他",
    "allSections": "すべての項目",
    "notFound": "案件が見つかりませんでした",
    "idLabel": "ID: {{id}}",
    "aiAssistant": "AIアシスタント",
    "progress": "進捗",
    "untilDeparture": "出発まで",
    "daysCount": "{{count}}日",
    "departsToday": "本日出発",
    "departed": "催行済み"
  },
  "paymentSection": {
    "title": "支払い",
    "exportCsv": "CSV出力",
    "csvFileName": "支払いスケジュール.csv",
    "addMilestone": "マイルストーン追加",
    "overdueAlert": "{{count}}件の支払いが期限を過ぎています",
    "unpaidTotal": "未払い合計",
    "paymentManagement": "入金管理",
    "totalAmount": "合計金額",
    "paidAmount": "入金済み",
    "remaining": "残額",
    "overdueCount": "{{count}}件 期限超過",
    "paymentProgress": "入金進捗",
    "timeline": "支払いタイムライン",
    "dueDateTbd": "未定",
    "paidDate": "入金日",
    "markPaid": "入金済みにする",
    "empty": "支払いマイルストーンが設定されていません",
    "scheduleTitle": "自社への入金予定",
    "addSchedule": "入金予定を追加",
    "scheduleEmpty": "まだ入金予定がありません。「＋ 入金予定を追加」から、お客様やパートナーからの入金を登録します。",
    "rowHint": "行を押すと編集できます。",
    "colSource": "入金元",
    "colLabel": "内容",
    "colDue": "期限",
    "colPlanned": "予定額",
    "colReceived": "入金済",
    "colStatus": "状態",
    "notEntered": "未入力",
    "statementPending": "精算書待ち",
    "sourceClient": "お客様",
    "sourcePartner": "パートナー",
    "clientFallback": "お客様",
    "partnerFallback": "パートナー",
    "summaryLine": "予定 {{total}} ・ 入金済 {{paid}} ・ 残り {{remaining}}",
    "partnerCard": {
      "title": "パートナーが預かっているお金",
      "notOurAccount": "自社の口座には入りません",
      "colFlow": "お客様 → パートナー",
      "colCollected": "入金額",
      "colPartnerCost": "パートナーの実費",
      "colSettlement": "自社への精算額",
      "enter": "入力",
      "enterSettlement": "精算額を入力",
      "collectedLabel": "お客様からパートナーへの入金額",
      "save": "保存",
      "cancel": "やめる",
      "settlementLabel": "旅行代金からの精算",
      "hint": "パートナーの実費は、損益タブで予算の行ごとに精算書の額を入れると集計されます。精算額は上の入金予定の「{{partner}}」の行に入ります。"
    },
    "type": {
      "deposit": "前金",
      "interim": "中間金",
      "final": "最終金"
    },
    "status": {
      "paid": "入金済み",
      "pending": "未入金",
      "overdue": "期限超過"
    }
  },
  "expenseCsvPreview": {
    "title": "CSV取込プレビュー",
    "noValidData": "有効なデータが見つかりませんでした。金額列は必須です。",
    "colVendor": "支払先",
    "colDate": "日付",
    "importSummary": "{{included}}/{{total}}件を取り込み",
    "totalAmount": "合計: ¥{{amount}}",
    "registering": "登録中...",
    "registerCount": "{{count}}件を登録",
    "importFailed": "インポートに失敗しました",
    "categoryAccommodation": "宿泊",
    "categoryTransport": "交通",
    "categoryContent": "コンテンツ",
    "categoryMeal": "食事",
    "categoryPmFee": "PM費用",
    "categoryCoachFee": "コーチ費",
    "categoryLabor": "人件費",
    "categoryOther": "その他"
  },
  "partnersPage": {
    "title": "パートナー管理",
    "addPartner": "パートナー追加",
    "searchPlaceholder": "パートナー名で検索...",
    "typeFilterPlaceholder": "種別",
    "allTypes": "すべての種別",
    "typeTravelAgency": "旅行会社",
    "typeContentProvider": "コンテンツ提供",
    "typeCoach": "コーチ",
    "columnCompanyName": "会社名",
    "columnType": "種別",
    "columnContactPerson": "担当者",
    "columnPhone": "電話番号",
    "columnEmail": "メール",
    "columnServices": "サービス",
    "columnRegions": "対応地域",
    "columnActions": "アクション",
    "emptyState": "該当するパートナーがありません",
    "partnerCount": "{{count}}件のパートナー",
    "regionFilterPlaceholder": "地域",
    "allRegions": "すべての地域"
  },
  "taskDialog": {
    "activityType": {
      "transport": "移動",
      "accommodation": "宿泊",
      "content": "コンテンツ",
      "meal": "食事",
      "free": "自由行動",
      "other": "その他"
    },
    "validation": {
      "titleRequired": "内容は必須です"
    },
    "title": {
      "edit": "タスクを編集",
      "add": "タスクを追加"
    },
    "field": {
      "date": "日付",
      "time": "時間",
      "type": "種別",
      "content": "内容",
      "partner": "パートナー",
      "note": "備考"
    },
    "placeholder": {
      "title": "例: ニューオータニ大阪 チェックイン",
      "partner": "パートナーを選択",
      "note": "補足情報"
    },
    "partner": {
      "none": "なし"
    },
    "submit": {
      "update": "更新",
      "add": "追加"
    }
  },
  "importPreview": {
    "entityParticipants": "参加者",
    "entityItinerary": "旅程",
    "entityQuoteItems": "経費概算",
    "entityPayments": "支払い",
    "title": "{{entity}}のCSVインポート",
    "fileReadError": "ファイル読み込みエラー: {{message}}",
    "selectCsvFile": "CSVファイルを選択してください",
    "dropZonePrompt": "CSVファイルをドロップ、または",
    "selectFile": "ファイルを選択",
    "dropZoneHint": "エクスポートしたCSVをそのまま取り込めます（_id列で更新判定）",
    "updateBadge": "更新 {{count}}件",
    "insertBadge": "新規 {{count}}件",
    "errorsHeading": "エラー ({{count}}件)",
    "moreItems": "...他{{count}}件",
    "columnType": "種別",
    "insertLabel": "新規",
    "updateLabel": "更新",
    "selectAnotherFile": "別のファイルを選択",
    "importButton": "インポート ({{count}}件)"
  },
  "formFieldEditor": {
    "fieldType": {
      "text": "短文",
      "textarea": "長文",
      "number": "数値",
      "email": "メール",
      "tel": "電話番号",
      "date": "日付",
      "select": "選択肢",
      "checkbox": "チェックボックス",
      "section": "区切り（見出し）"
    },
    "label": "ラベル",
    "labelPlaceholder": "例: お名前",
    "type": "タイプ",
    "moveUp": "上へ",
    "moveDown": "下へ",
    "placeholderLabel": "プレースホルダー (任意)",
    "helpTextLabel": "補足説明 (任意)",
    "optionsLabel": "選択肢 (1行に1つ)",
    "optionsPlaceholder": "選択肢A\n選択肢B\n選択肢C",
    "required": "必須項目"
  },
  "pdfImport": {
    "target": {
      "itinerary": "旅程",
      "quoteItems": "経費概算",
      "participants": "参加者"
    },
    "title": "PDFから{{target}}を取り込み",
    "error": {
      "notPdf": "PDFファイルを選択してください",
      "fileTooLarge": "ファイルサイズは4MB以下にしてください（base64変換のため）",
      "emptyResult": "AI解析結果が空でした。別のPDFをお試しください。",
      "parseFailed": "AI解析エラー: {{message}}"
    },
    "analyzing": "AI解析中...",
    "analyzingDescription": "PDFの内容を読み取って構造化しています",
    "dropZone": "PDFファイルをドロップ、または",
    "selectFile": "ファイルを選択",
    "supportedDocuments": "旅行会社の見積もり、予約確認書、参加者名簿などのPDFに対応",
    "extractedCount": "{{count}}件 抽出",
    "moreRows": "...他{{count}}件",
    "selectAnotherFile": "別のファイルを選択",
    "importAction": "取り込み ({{count}}件)"
  },
  "expenseOcr": {
    "title": "レシート/請求書から経費登録",
    "uploadPrompt": "レシートや請求書の画像/PDFをアップロード",
    "selectFile": "ファイルを選択",
    "supportedFormats": "対応形式: JPG, PNG, PDF",
    "analyzing": "AIが画像を解析中...",
    "category": "カテゴリ",
    "date": "日付",
    "vendor": "支払先",
    "register": "経費を登録",
    "errorExtractFailed": "データを抽出できませんでした。手動で入力してください。",
    "errorParseFailed": "画像の解析に失敗しました。手動で入力してください。",
    "errorAmountRequired": "金額を入力してください",
    "categoryAccommodation": "宿泊",
    "categoryTransport": "交通",
    "categoryContent": "コンテンツ",
    "categoryMeal": "食事",
    "categoryPmFee": "PM費用",
    "categoryCoachFee": "コーチ費",
    "categoryLabor": "人件費",
    "categoryOther": "その他"
  },
  "revenue": {
    "title": "収益管理",
    "tabPl": "PL概要",
    "tabSales": "売上管理",
    "tabPayments": "入金管理",
    "tabExpenses": "経費管理",
    "revenueBudget": "売上（予算）",
    "expenseEstimate": "経費概算",
    "expenseActual": "経費実績",
    "grossProfitEstimateBase": "粗利（概算ベース）",
    "plSummary": "損益サマリー",
    "grossProfitEstimate": "粗利（概算）",
    "grossProfitActual": "粗利（実績）",
    "paymentStatus": "入金状況",
    "paidOverDue": "入金済み / 請求合計"
  },
  "formBuilder": {
    "templateNotFound": "テンプレートが見つかりません",
    "backToFormList": "フォーム一覧に戻る",
    "back": "戻る",
    "saving": "保存中...",
    "publishDistribute": "公開・配布",
    "linkagePrereqPrefix": "参加者連携 (直接登録 / 選考制) で公開するには、",
    "fieldJoiner": " と ",
    "linkagePrereqSuffix": " フィールドが必要です。「アンケート (連携なし)」モードであれば不要。",
    "formName": "フォーム名",
    "formNamePlaceholder": "例: 参加者情報フォーム",
    "descriptionOptional": "説明 (任意)",
    "descriptionPlaceholder": "申込者向けの案内文...",
    "questions": "質問項目 ({{count}})",
    "addField": "項目追加",
    "noQuestionsYet": "質問項目がまだありません",
    "addFirstField": "最初の項目を追加"
  },
  "quickTour": {
    "welcomeTitle": "atsume.camp へようこそ",
    "welcomeBody": "団体旅行・合宿の企画から見積・手配・精算までを 1 つで管理できます。主要な機能をさっと見てみましょう。",
    "dashboardTitle": "ダッシュボード",
    "dashboardBody": "進行中の案件と進捗を一覧で把握できます。ここから案件を開いて作業を始めます。",
    "campsTitle": "案件一覧 と 案件詳細",
    "campsBody": "案件ごとに 旅程・参加者・パートナー手配・タスク をタブで管理。出発までのカウントダウンや進捗も表示されます。",
    "revenueTitle": "収益管理 — 原価から料金を自動計算",
    "revenueBody": "「原価管理」にホテル代や航空券を区分（共通／大人／子供／幼児）付きで入力すると、「売上管理」で区分別のツアー料金が自動計算されます。利益率・利益額も設定可。経費管理ではレシート画像も保存できます。",
    "formsTitle": "フォーム",
    "formsBody": "公開フォームを発行して参加者情報を回収。回答はそのまま申込者・参加者として取り込めます。",
    "aiTitle": "AIアシスタント",
    "aiBody": "案件を開くと右側の AI アシスタントが使えます。旅程の改善や見積の相談ができます。",
    "skip": "スキップ",
    "close": "閉じる",
    "back": "戻る",
    "start": "はじめる",
    "next": "次へ（{{current}}/{{total}}）"
  },
  "partnerDialog": {
    "titleEdit": "パートナーを編集",
    "titleAdd": "パートナーを追加",
    "companyName": "会社名",
    "type": "種別",
    "contactPerson": "担当者名",
    "email": "メール",
    "phone": "電話",
    "services": "サービス内容（カンマ区切り）",
    "servicesPlaceholder": "例: サッカー, ラグビー, 茶道",
    "regions": "対応地域（カンマ区切り）",
    "regionsPlaceholder": "例: 東京, 大阪, 北海道",
    "update": "更新",
    "add": "追加",
    "errorNameRequired": "会社名は必須です",
    "errorEmailInvalid": "有効なメールアドレスを入力してください"
  },
  "noteDialog": {
    "editTitle": "メモを編集",
    "addTitle": "メモを追加",
    "typeLabel": "種別",
    "typePlaceholder": "種別を選択",
    "titleLabel": "タイトル",
    "titlePlaceholder": "例: キックオフミーティング",
    "contentLabel": "内容",
    "contentPlaceholder": "メモの内容を入力",
    "update": "更新",
    "add": "追加",
    "noteType": {
      "payment": "入金メモ"
    },
    "errors": {
      "typeRequired": "種別を選択してください",
      "titleRequired": "タイトルは必須です"
    }
  },
  "notesSection": {
    "title": "メモ",
    "aiSummary": "AI要約",
    "addNote": "メモ追加",
    "empty": "メモがまだありません",
    "shareEmail": "メールで共有",
    "shareEmailSubject": "【atsume.camp】{{title}}",
    "shareEmailBody": "{{title}}\n\n{{content}}\n\n---\natsume.camp より",
    "summarizePrompt": "以下のミーティングノートを簡潔に要約してください。決定事項とアクションアイテムを箇条書きで:",
    "error": "エラー",
    "summarizeFailed": "要約の生成に失敗しました"
  },
  "formsPage": {
    "title": "フォーム",
    "subtitle": "申込者から情報を回収するためのフォームテンプレートを管理します",
    "newTemplate": "新規テンプレート",
    "newFormName": "新規フォーム",
    "archiveConfirm": "このテンプレートをアーカイブしますか？",
    "emptyTitle": "テンプレートがまだありません",
    "emptyHint": "「新規テンプレート」をクリックして最初のフォームを作成してください",
    "fieldCount": "{{count}} 項目",
    "archiveAction": "アーカイブ"
  },
  "paymentMilestoneDialog": {
    "amountMinError": "0以上の数値を入力してください",
    "editTitle": "マイルストーンを編集",
    "addTitle": "マイルストーンを追加",
    "typeLabel": "種別",
    "typePlaceholder": "種別を選択",
    "percentageLabel": "割合（%）",
    "amountLabel": "金額（円）",
    "dueDateLabel": "期日",
    "sourceLabel": "入金元",
    "sourceClient": "お客様",
    "sourcePartner": "パートナー",
    "labelLabel": "内容",
    "labelPlaceholder": "例: コンサル料 A$32,331",
    "updateButton": "更新",
    "addButton": "追加"
  },
  "instanceSettings": {
    "invalidEmailFormat": "不正なメール形式: {{email}}",
    "invalidSlug": "スラッグは英小文字・数字・ハイフンのみ、先頭末尾は英数字",
    "title": "公開URL設定",
    "description": "応募処理モード・URL スラッグ・通知メールを変更できます。",
    "linkModeLabel": "応募処理モード",
    "slugLabel": "URL スラッグ",
    "slugHintPrefix": "空欄にすると",
    "slugHintSuffix": "形式になります",
    "notifyEmailsLabel": "通知メール",
    "notifyEmailsHint": "回答送信時にこの宛先へ通知メールが送られます。複数はカンマ区切り。"
  },
  "aiChat": {
    "systemPrompt": "あなたはatsume.camp（団体旅行プランニングプラットフォーム）のAIアシスタントです。\n旅程の提案、見積もりの最適化、タスクの自動生成、参加者管理のアドバイスなどをサポートします。\n日本語で回答してください。簡潔で実用的な回答を心がけてください。",
    "systemPromptContextLabel": "以下は現在の案件データです：",
    "suggestionImproveItinerary": "旅程の改善点を提案して",
    "suggestionOptimizeBudget": "予算の最適化案を出して",
    "suggestionListTasks": "必要なタスクを洗い出して",
    "suggestionDraftPartnerMessage": "パートナーへの連絡文を作成して",
    "emptyStateDescription": "案件に関する質問や作業の依頼ができます",
    "inputPlaceholder": "メッセージを入力...",
    "genericError": "エラーが発生しました",
    "responseFailed": "AIの応答に失敗しました",
    "close": "閉じる"
  },
  "landingEditor": {
    "tabHero": "Hero",
    "tabAudiences": "Audiences",
    "tabEvents": "Events",
    "tabLayout": "Layout",
    "tabPublish": "Publish",
    "createPrompt": "新しい landing の subdomain slug（例: atsu）:",
    "slugInvalid": "slug は 2-40 文字、英小文字 / 数字 / ハイフンのみ。",
    "createFailed": "作成に失敗: {{message}}",
    "noPermissionTitle": "権限がありません",
    "noPermissionDescription": "このページの編集にはテナント管理者 (admin) ロールが必要です。",
    "emptyTitle": "まだ landing がありません",
    "emptyDescription": "このテナント用の最初の landing page を作成しましょう。",
    "new": "新規",
    "preview": "プレビュー",
    "saved": "保存しました",
    "previewLoading": "プレビューを読み込み中..."
  },
  "revenueTab": {
    "modeCogsLabel": "原価から自動計算",
    "modeCogsDesc": "原価管理の入力から区分別のツアー料金を自動算出",
    "modeParticipantsLabel": "参加者ごとの金額",
    "modeParticipantsDesc": "参加者タブで設定した一人ごとの金額を合計",
    "modeRoughLabel": "ざっくり総額",
    "modeRoughDesc": "売上の概算を一括で入力",
    "participantTotal": "参加者 {{count}}名 の合計",
    "participantHint": "金額は「参加者」タブで一人ずつ設定します。ここでの合計がそのまま売上になります。",
    "roughTitle": "売上のざっくり総額",
    "roughPlaceholder": "例: 1500000",
    "saved": "保存しました",
    "roughHint": "原価や参加者の入力が固まる前の概算用です。"
  },
  "quoteComparison": {
    "title": "見積もり比較",
    "categoryLineItem": "カテゴリ / 明細",
    "category": {
      "accommodation": "宿泊",
      "transport": "交通",
      "content": "コンテンツ",
      "meal": "食事",
      "pmFee": "PM費用",
      "other": "その他"
    }
  },
  "dash": {
    "pipelineFunnel": {
      "title": "パイプライン"
    },
    "morningSummary": {
      "title": "今日の優先",
      "count": "{{count}} 件",
      "empty": "今日対応すべき案件はありません。穏やかな朝を。",
      "departToday": "本日出発",
      "departInDays": "出発まで {{count}} 日",
      "paymentDeposit": "デポジット",
      "paymentInterim": "中間金",
      "paymentFinal": "最終金",
      "paymentOverdue": "{{label}}が {{count}} 日超過",
      "paymentDueToday": "{{label}}が本日期限",
      "paymentDueInDays": "{{label}}まで {{count}} 日",
      "highPriorityTasks": "高優先度タスク {{count}} 件未完了",
      "showTop3": "上位 3 件のみ表示",
      "showMore": "他 {{count}} 件を表示"
    },
    "kpiCards": {
      "revenue": "売上見込",
      "revenueSub": "{{count}}件の案件",
      "pax": "参加者",
      "paxSub": "{{count}}案件合計",
      "avgProgress": "平均進捗",
      "avgProgressSub": "アクティブ案件",
      "attention": "要対応",
      "attentionSub": "出発14日以内・進捗80%未満"
    },
    "alertBanner": {
      "remindSubject": "【atsume.camp】{{campName}} 支払いリマインド",
      "remindBody": "{{campName}}の支払い期限が近づいています。\n\n期限: {{detail}}\n\nご確認をお願いいたします。",
      "remind": "リマインド送信",
      "remaining": "残り {{value}} 件",
      "viewDetails": "詳細を見る",
      "close": "閉じる"
    },
    "dashboardSummary": {
      "active": "進行中",
      "activeValue": "{{count}}件",
      "activeSub": "全{{count}}件中",
      "participants": "参加者計",
      "participantsValue": "{{value}}名",
      "budget": "総予算",
      "deadlines": "今月の締切",
      "deadlinesValue": "{{count}}件"
    },
    "seasonView": {
      "seasonOverview": "シーズン概要",
      "subtitle": "進行中の案件をタイムラインで確認。カードをクリックして詳細を開きます。",
      "focusSub": "今週対応が必要な案件",
      "today": "本日",
      "days": "{{count}}日"
    },
    "kanbanBoard": {
      "title": "パイプライン",
      "subtitle": "ステータス別にカード表示。リスクのある案件は赤いカウントダウン。",
      "empty": "案件なし"
    },
    "timelineView": {
      "title": "タイムライン",
      "status": "ステータス",
      "destination": "行き先"
    }
  },
  "tenantLanding": {
    "layoutForm": {
      "blockHero": "Hero",
      "blockInfoDashboard": "Info Dashboard",
      "blockRichText": "Rich Text",
      "blockAudienceCategories": "Audience Categories",
      "blockEventList": "Event List",
      "blockCalendar": "Calendar",
      "intro": "ページに並べるブロックの順番。Hero は通常先頭に置きます。",
      "richTextPlaceholder": "# 見出し\n\n本文...",
      "filterLabel": "フィルタ:",
      "showPast": "過去のイベントも表示",
      "calendarRangeLabel": "範囲:",
      "rangeAll": "すべて",
      "rangeUpcoming": "今後のみ",
      "rangePast": "過去のみ",
      "addSection": "追加"
    },
    "publishPanel": {
      "domainError": "公開フラグは保存しました。CF Pages ドメイン登録でエラー: {{message}}",
      "publishLabel": "公開する",
      "publishHintPrefix": "ON にすると",
      "publishHintSuffix": "で配信されます。",
      "publishHintDomain": "初回は Cloudflare Pages にカスタムドメインを登録するため、数分〜10 分ほどかかる場合があります。",
      "preview": "プレビュー",
      "infoTitle": "情報",
      "infoAdminOnly": "公開は組織管理者 (admin) のみが切替できます",
      "infoPauseKeepsSettings": "一時停止しても、設定内容は残ります（再 ON で復活）",
      "infoDomainOnce": "ドメイン登録は初回のみ。一度登録した {{domain}} は CF Pages に残り続けます"
    },
    "eventsForm": {
      "intro": "手動で追加するイベント。DB の camps と組み合わせて表示されます。同じ id の camp があれば上書きされます。",
      "empty": "まだ手動エントリがありません。",
      "idHint": "camp の id と一致させると、その camp 表示を上書きします",
      "urlLabel": "URL (内部 /f/... または外部 https://...)",
      "heroImageLabel": "Hero image (optional)",
      "addEvent": "イベントを追加"
    },
    "audiencesForm": {
      "intro": "受講者カテゴリ（経営向け／個人向け／企業向け 等）。各イベントに付ける audience タグはここで定義したキーから選びます。",
      "empty": "まだカテゴリがありません。下の「追加」から作成してください。",
      "labelJpPlaceholder": "経営向け",
      "addCategory": "カテゴリを追加"
    },
    "heroForm": {
      "eyebrowHint": "タイトルの上に小さく表示されるラベル（任意）",
      "subtitlePlaceholder": "一文〜二文の説明",
      "backgroundImageLabel": "Background Image",
      "backgroundImageHint": "推奨: 1920x1080px / WebP / 暗めの写真。OG 画像にも使われます。"
    },
    "imageUpload": {
      "errorNotImage": "画像ファイルを選択してください",
      "errorTooLarge": "10MB 以下のファイルを選択してください",
      "replace": "差し替え",
      "upload": "アップロード"
    },
    "infoDashboard": {
      "forWhomSub": "対象",
      "detail": "詳細 →",
      "upcomingSub": "直近の予定",
      "upcomingEmpty": "直近の予定はまだ公開されていません",
      "calendarSub": "日程"
    },
    "audienceCategories": {
      "intro": "それぞれのカテゴリで、開催形態とねらいが違います。気になるところから読んでください。",
      "sessionsEmpty": "まだセッションは公開されていません。順次このページで公開していきます。"
    },
    "sakurai": {
      "audiencesDivider": "{{count}} つのカテゴリ。それぞれ異なるねらい。",
      "sessionsDivider": "直近 {{count}} 件。日付順に並べています。",
      "detail": "詳細 →",
      "calendarHeading": "日程"
    },
    "audienceDetail": {
      "notFound": "プラン情報が見つかりません",
      "themesSub": "テーマ — 学べる / 持ち帰れること",
      "processSub": "リズム — 日々・週・月の流れ",
      "outcomesSub": "3 ヶ月後の状態 — 例",
      "faqSub": "よくある質問",
      "ctaDefault": "問い合わせ",
      "ctaSecondaryDefault": "予約"
    },
    "eventDetail": {
      "notFound": "セッションが見つかりません",
      "applyCta": "詳細を見る / 申し込む",
      "closedTitle": "Closed — このセッションは終了しました",
      "closedBody": "次回開催は schedule からご確認ください。"
    }
  },
  "misc": {
    "paymentMemos": {
      "title": "変更メモ / 履歴",
      "count": "{{count}}件",
      "noteTitle": "入金メモ",
      "placeholder": "例: 参加人数が25名→22名へ変更。最終金額再計算済み",
      "add": "メモを追加",
      "empty": "まだメモはありません。料金や条件の変更があった際に履歴として残せます。",
      "editedAt": "（編集: {{date}}）",
      "deleteConfirm": "このメモを削除します。この操作は取り消せません。"
    },
    "aiSidebarPanel": {
      "title": "AIアシスタント",
      "close": "AIアシスタントを閉じる",
      "selectCamp": "案件を選択してください",
      "emptyHintBefore": "ダッシュボードから案件を開くと",
      "emptyHintAfter": "AIアシスタントが利用できます",
      "prompt": "質問や作業の依頼ができます",
      "suggestionItinerary": "旅程の改善点を提案して",
      "suggestionBudget": "予算の最適化案を出して",
      "suggestionTasks": "必要なタスクを洗い出して",
      "inputPlaceholder": "メッセージを入力...",
      "inputLabel": "AIアシスタントへのメッセージ"
    },
    "campOverview": {
      "tabOverview": "概要",
      "tabItinerary": "旅程",
      "tabRevenue": "収益管理",
      "tabParticipants": "参加者",
      "tabPartners": "パートナー",
      "tabTasks": "タスク",
      "tabNotes": "メモ",
      "openDetail": "詳細を開く",
      "share": "共有"
    },
    "statusChange": {
      "description": "案件のステータスを変更します。",
      "selectPlaceholder": "新しいステータスを選択",
      "currentSuffix": "（現在）",
      "backwardWarning": "ステータスを戻そうとしています。関連するデータに影響がある可能性があります。",
      "confirm": "変更"
    },
    "receiptUpload": {
      "invalidType": "画像（PNG/JPEG/WebP）または PDF を選択してください",
      "tooLarge": "10MB 以下のファイルを選択してください",
      "uploadFailed": "アップロードに失敗しました",
      "receipt": "領収書",
      "removeReceipt": "領収書を削除",
      "replace": "差し替え",
      "upload": "領収書をアップロード"
    },
    "campListItem": {
      "budgetMan": "{{value}}万円",
      "budgetYen": "{{value}}円",
      "pax": "{{count}}名",
      "deadline": "{{date}}期限"
    },
    "app": {
      "notFound": "ページが見つかりませんでした",
      "backToDashboard": "ダッシュボードに戻る",
      "unexpectedError": "予期しないエラーが発生しました",
      "reload": "ページを再読み込み"
    },
    "publicFormThanks": {
      "line1": "ご応募ありがとうございます。",
      "line2": "内容を確認のうえ、追ってご連絡差し上げます。",
      "closeNotice": "このページは閉じていただいて構いません"
    },
    "qrPopover": {
      "show": "QRコードを表示",
      "generating": "生成中…"
    },
    "appLayout": {
      "navigation": "ナビゲーション",
      "menu": "メニュー"
    },
    "appContext": {
      "syncFailed": "データの保存に失敗しました: {{message}}"
    },
    "timeline": {
      "title": "タイムライン"
    },
    "dialog": {
      "close": "閉じる"
    }
  },
  "sidebar": {
    "switchTenant": "テナント切替",
    "openAi": "AIアシスタントを開く",
    "aiNoCamp": "AIアシスタント(案件未選択)",
    "aiAssistant": "AIアシスタント",
    "selectCampPrompt": "案件を選択してください",
    "selectCampToUseAi": "案件を選択するとAIアシスタントが使えます",
    "expand": "サイドバーを展開",
    "collapseAria": "サイドバーを折りたたむ",
    "collapse": "折りたたむ",
    "profileMenu": "プロフィールメニュー",
    "quickTour": "クイックツアー",
    "lightMode": "ライトモード",
    "darkMode": "ダークモード",
    "logout": "ログアウト"
  },
  "linkMode": {
    "selection": {
      "label": "選考制 (採用判断後に登録)",
      "description": "回答 = 応募。FormResponses 画面で「採用」したものだけが参加者に登録されます"
    },
    "auto": {
      "label": "直接登録 (回答 = 即参加者)",
      "description": "回答時に participants へ自動登録 (status: registered)。重複は email + 名前で検出"
    },
    "none": {
      "label": "連携なし (アンケート用)",
      "description": "回答だけ蓄積。参加者管理とは無関係"
    },
    "preEvent": {
      "label": "参加者事前回答 (登録済みの方向け)",
      "description": "申込ではなく、すでに登録済みの参加者から事前情報を集める用途"
    }
  },
  "alerts": {
    "incompleteTasks": "開始まで{{days}}日、未完了タスクが{{count}}件あります",
    "paymentDue": "支払い期限まで{{days}}日（{{label}}）",
    "deadlinePayment": "{{label}}支払い",
    "paymentType": {
      "deposit": "手付金",
      "interim": "中間金",
      "final": "最終金"
    }
  },
  "bus": {
    "tab": "バス手配",
    "empty": "この案件の行程にバスの予定がありません。行程表でバスの予定を足すと、ここに手配一覧が出ます。",
    "dayCount": "バスが要る日 {{count}}日",
    "legCount": "便 {{count}}件",
    "noTime": "時刻未設定 {{count}}件",
    "export": "CSVで書き出す",
    "capacity": "車種",
    "capacity11": "11列（補助席込み55名）",
    "capacity12": "12列（補助席込み60名）",
    "paxAndBuses": "人数と台数",
    "busesFor": "{{pax}}名 → {{count}}台",
    "paxUnknown": "人数が未入力",
    "quotedDays": "見積もりの日数",
    "quotedShort": "見積もりが{{count}}日足りません",
    "quotedOver": "見積もりが{{count}}日多いです",
    "quotedMatch": "行程と一致しています",
    "capacityWarning": "{{pax}}名は{{capacity}}名の定員を超えるので{{count}}台要ります。1台増えると1日あたり約20万円かかります。",
    "daySpan": "拘束 {{span}}",
    "timeTbd": "時刻未定",
    "hint": "この表は行程表から自動で出しています。行程を直せばここも変わります。そのまま手配の根拠として渡せます。",
    "col": {
      "day": "日",
      "date": "日付",
      "time": "時刻",
      "route": "区間・用務",
      "duration": "拘束時間",
      "pax": "人数",
      "buses": "台数",
      "note": "備考"
    },
    "riders": "乗車人数",
    "staffNotIncluded": "空欄なら案件の参加者数（{{pax}}名）で計算します。運営スタッフ・コーチは含まれていません。",
    "untypedTransport": "交通の予定のうち、手段が選ばれていないものが{{count}}件あります。バスなら「バス」を選ばないとこの一覧に出ません。",
    "orphans": "日に紐づいていない予定が{{count}}件あり、どの一覧にも出ていません。",
    "untilDate": "（{{date}} まで）",
    "paxInvalid": "0以上の整数で入力してください。いまは案件の人数で計算しています。",
    "endDateTooLong": "終了日が開始から1年を超える便が{{count}}件あります。入力ミスの可能性があるので、日数には開始日だけを数えています。"
  },
  "travel": {
    "issue": {
      "dobInvalid": "生年月日が日付として読めません（{{value}}）",
      "dobFuture": "生年月日が未来の日付です（{{value}}）",
      "dobAfterStart": "生年月日がツアー開始日より後です（{{value}}）",
      "dobMissing": "生年月日が未入力です",
      "genderMissing": "性別が未入力です",
      "romanMissing": "ローマ字の氏名が未入力です",
      "nationalityMissing": "国籍が未入力です",
      "passportMissing": "パスポート番号が未入力です",
      "expiryInvalid": "パスポート有効期限が日付として読めません（{{value}}）",
      "expiryBeforeEnd": "パスポートがツアー終了前に失効します（{{value}}）",
      "expirySoon": "パスポートの残存期間が6ヶ月を切っています（{{value}}）",
      "expiryMissing": "パスポート有効期限が未入力です",
      "visaRequired": "ビザ申請が要る可能性があります（{{value}}）",
      "visaConditional": "条件つきでビザ免除の国籍です（{{value}}）",
      "arrivalMissing": "到着便が未入力です",
      "departureMissing": "出発便が未入力です",
      "visaUnknown": "国籍「{{value}}」のビザ要否を判定できません。代理店に確認してください",
      "fieldInvalid": "{{value}} の値が壊れています（文字列ではありません）"
    },
    "summary": {
      "title": "渡航情報の不足",
      "errors": "要対応 {{count}}件",
      "warnings": "確認 {{count}}件",
      "flightMissing": "便が未回収 {{count}}名",
      "visaRequired": "要ビザの可能性 {{count}}名",
      "spelling": "姓の綴りが割れています",
      "spellingHint": "綴りが1〜2文字違う姓が混在しています。同じ家族なら表記を揃えてください（家族かどうかまでは判定していません）。",
      "ok": "渡航情報はそろっています",
      "showOnlyIssues": "不足がある人だけ表示",
      "latestArrival": "いちばん遅い到着",
      "departureMissing": "出発便が未回収 {{count}}名",
      "markInternational": "海外渡航の案件として扱う",
      "sameRoom": "同室",
      "arrivalGroups": "到着便ごとの人数（{{count}}便）",
      "arrivalTimeUnknown": "時刻未定",
      "people": "{{count}}名",
      "visaPending": "ビザ手続き未完了 {{count}}名"
    }
  },
  "changeFeed": {
    "title": "最近の変更",
    "unseen": "前回から{{count}}件",
    "markSeen": "既読にする",
    "loading": "読み込み中…",
    "failed": "変更履歴を読み込めませんでした",
    "empty": "まだ変更はありません",
    "unknownActor": "だれか",
    "showAll": "すべて表示（{{count}}件）",
    "showLess": "閉じる",
    "line": "{{who}}が{{entity}}を{{op}}",
    "entity": {
      "activity": "予定",
      "itinerary_day": "日程",
      "participant": "参加者",
      "comment": "コメント",
      "other": "記録"
    },
    "op": {
      "insert": "追加",
      "update": "変更",
      "delete": "削除"
    },
    "field": {
      "description": "内容",
      "time": "開始",
      "end_time": "終了",
      "type": "種別",
      "itinerary_day_id": "日",
      "day_number": "日番号",
      "date": "日付",
      "theme": "テーマ",
      "name": "名前",
      "status": "状況",
      "role": "役割",
      "room_assignment": "部屋"
    },
    "moved": "を別の日へ移動",
    "unseenMany": "前回から{{count}}件以上"
  },
  "shareLinks": {
    "open": "共有リンク",
    "title": "旅程の共有リンク",
    "description": "ログインなしで旅程を見られるリンクを作ります。社内メモ・金額・手配先は表示されません。期限が来るか取り消すと見られなくなります。",
    "validFor": "有効期間",
    "days": "{{count}}日",
    "includeNotes": "備考も見せる",
    "create": "リンクを作る",
    "copy": "コピー",
    "copied": "コピーしました",
    "revoke": "取り消す",
    "until": "{{date}} まで",
    "withNotes": "備考あり",
    "none": "まだリンクはありません",
    "loadFailed": "リンクを読み込めませんでした",
    "createFailed": "リンクを作れませんでした",
    "revokeFailed": "取り消せませんでした",
    "copyFailed": "コピーできませんでした。URL を選択してコピーしてください",
    "state": {
      "active": "有効",
      "expired": "期限切れ",
      "revoked": "取り消し済み"
    }
  },
  "today": {
    "tab": "当日",
    "title": "当日モード",
    "isToday": "今日",
    "dayChip": "Day{{n}} {{date}}",
    "noDates": "旅程に日付が入っていません。旅程の各日に日付を入れると、当日の画面が使えます。",
    "schedule": "予定",
    "scheduleDay": "Day{{n}} の予定",
    "noActivities": "この日の予定はありません",
    "noTime": "時刻なし",
    "tbd": "（仮）",
    "arrivals": "この日に着く便",
    "unknownFlight": "便名なし",
    "people": "{{count}}人",
    "rollCall": "点呼",
    "presentCount": "{{present}} / {{total}}",
    "refresh": "最新にする",
    "defaultLabel": "集合",
    "newLabel": "点呼の名前",
    "addLabel": "追加",
    "search": "名前・部屋で探す",
    "missingOnly": "未着だけ",
    "loadFailed": "点呼を読み込めませんでした。電波の良い場所で「最新にする」を押してください。",
    "saveFailed": "保存できませんでした。もう一度押してください。",
    "loading": "読み込み中…",
    "allPresent": "全員そろっています",
    "noMatch": "該当する人がいません",
    "rooms": "部屋割り（{{count}}部屋）",
    "show": "開く",
    "hide": "閉じる",
    "unassigned": "未割当",
    "contacts": "運営の連絡先"
  },
  "headcount": {
    "title": "人数の推移",
    "show": "開く",
    "hide": "閉じる",
    "loading": "読み込み中…",
    "failed": "履歴を読み込めませんでした",
    "noChanges": "記録を始めてから人数の増減はありません（いま {{count}}人）",
    "endOfDay": "この日の終わり {{count}}人",
    "unknownName": "（名前なし）",
    "since": "記録は {{date}} から。その直前は {{count}}人",
    "truncated": "古い履歴は省略しています（{{date}} の直前は {{count}}人）",
    "truncatedNoDate": "古い履歴は省略しています",
    "unknownActor": "不明",
    "syncing": "保存中の変更があります。反映されたら人数を合わせます"
  },
  "disclosure": {
    "field": "先方に伝えたか",
    "unset": "未設定",
    "internal": "社内のみ",
    "partial": "一部のみ伝達",
    "shared": "伝達済み",
    "internalHint": "共有リンクの旅程と、社内メモなしのPDFには出ません。",
    "noteLabel": "何を伝えていないか",
    "notePlaceholder": "例: 金額は未伝達／東京のホテルが別になる可能性は未伝達",
    "undisclosed": "未伝達 {{count}}件",
    "undisclosedHint": "社内のみ・一部のみ伝達のものです。",
    "pdfExcluded": "「社内のみ」の予定 {{count}}件は、社内メモを含めない出力では載りません。",
    "undisclosedBreakdown": "予定 {{activities}}件・金額 {{quotes}}件・部屋割り {{rooming}}件",
    "exportConfirm": {
      "internal": "この内容は「社内のみ」になっています。先方に渡る形で出しますか？{{note}}",
      "partial": "この内容は「一部のみ伝達」です。伝えていないものが含まれていないか確認してください。出しますか？{{note}}"
    },
    "internalFileTag": "社内限定"
  },
  "addPax": {
    "title": "あと何人まで入るか",
    "description": "いまの手配（仮予約・バス・見積）で、追加の打診を受けられるかを出します。",
    "addLabel": "追加",
    "people": "{{count}}名",
    "segmentLabel": "区分",
    "rooms": "部屋",
    "roomsUnknown": "仮予約のメモが無いので判定できません（案件メモに「仮予約」を書くと出ます）。",
    "roomsFit": "いまの手配で入ります（{{tightest}}：空き {{free}}床 / 予約 {{reserved}}床）",
    "roomsShort": "{{shortfall}}床 足りません（{{tightest}}：空き {{free}}床 / 予約 {{reserved}}床）",
    "bus": "バス",
    "busSame": "いまの {{before}}台のまま（定員 {{capacity}}名）",
    "busMore": "{{extra}}台 増えます（{{before}}台 → {{after}}台・定員 {{capacity}}名）",
    "cost": "費用",
    "costUnknown": "この区分の一人あたりが見積から出せません（見積に区分を紐づけると出ます）。",
    "costDelta": "{{total}} 増（一人あたり {{perPerson}}）",
    "footer": "人数は {{before}}名 → {{after}}名。バスの追加費用は見積の該当行を見てください（ここでは台数だけ出します）。",
    "segment": {
      "adult": "大人",
      "adult_2": "大人（区分2）",
      "child": "子ども",
      "infant": "幼児",
      "other": "その他"
    }
  },
  "tax": {
    "title": "税区分",
    "undecided": "未確定",
    "excl": "税抜",
    "incl": "税込",
    "quoteLabel": "見積 v{{version}}",
    "quoteLabelNone": "見積（まだありません）",
    "invoiceLabel": "インボイス",
    "invoiceYes": "要",
    "invoiceNo": "不要",
    "noteLabel": "税まわりのメモ",
    "notePlaceholder": "例: 西鉄とは税抜で握る方向・税理士に確認中",
    "unknown": "税区分未確定 {{count}}件",
    "unknownHint": "税抜か税込かが決まっていない金額です。取り違えると手取りが変わります。",
    "breakdown": "見積 {{quote}}件・明細 {{items}}件・原価 {{costs}}件・入金 {{payments}}件",
    "alignCosts": "原価 {{count}}件が未確定",
    "alignPayments": "入金 {{count}}件が未確定",
    "alignTo": "{{mode}}にそろえる"
  },
  "decisions": {
    "title": "決めたこと",
    "add": "決定を足す",
    "save": "保存",
    "empty": "まだ決定が入っていません。決まった日・決めた人・根拠を残すと、あとで聞かれたときに画面が答えます。",
    "failed": "決定を読み書きできませんでした。",
    "untold": "未共有 {{count}}件",
    "notShared": "未共有",
    "decidedOn": "決まった日",
    "decidedBy": "決めた人・決めた場",
    "decidedByPlaceholder": "例: 粟田 / 西鉄との定例",
    "titleLabel": "決めたこと",
    "titlePlaceholder": "例: 新幹線代は3,850に含む",
    "detail": "内訳・補足",
    "detailPlaceholder": "例: 内訳は新幹線1,200＋宿2,650",
    "source": "根拠の在りか",
    "sourcePlaceholder": "例: 議事録URL / LINE 6-25",
    "sharedWith": "伝えた先",
    "sharedWithPlaceholder": "例: 西鉄・Gerard",
    "sharedWithValue": "{{who}} に伝達済み",
    "delete": "削除"
  },
  "staffSection": {
    "title": "添乗員・コーチ",
    "add": "割り当てる",
    "modeNew": "新しく追加",
    "modeExisting": "名簿から選ぶ",
    "name": "名前",
    "namePlaceholder": "例: 山田太郎",
    "role": "役割",
    "rolePlaceholder": "例: コーチ",
    "pickExisting": "スタッフを選ぶ",
    "pickExistingPlaceholder": "選択してください",
    "roleDescription": "この案件での役割（任意）",
    "roleDescriptionPlaceholder": "例: 点呼担当",
    "daysLabel": "帯同する日（未選択なら常時帯同）",
    "alwaysAccompanying": "常時帯同",
    "specificDays": "{{count}}日だけ帯同",
    "save": "保存",
    "empty": "まだ誰も割り当てられていません。",
    "failed": "スタッフを読み書きできませんでした。",
    "remove": "割り当て解除"
  },
  "reconciliation": {
    "title": "着金の記録",
    "hint": "自社の口座に入ったお金を1件ずつ記録し、どの入金予定に充てるかを選びます。合計が損益タブの「入金額」になります。",
    "milestone": "充てる入金予定",
    "overallPct": "着金累計 {{pct}}%",
    "billedReceived": "請求 {{billed}}・着金 {{received}}",
    "short": "{{amount}} 不足",
    "over": "{{amount}} 超過",
    "addReceipt": "着金を記録",
    "receivedOn": "着金日",
    "amount": "金額（円）",
    "amountPlaceholder": "例: 2400630",
    "foreignCurrency": "通貨",
    "foreignCurrencyPlaceholder": "例: AUD",
    "foreignAmount": "送金元の金額",
    "foreignAmountPlaceholder": "例: 23219",
    "note": "メモ",
    "notePlaceholder": "例: 下3桁見間違い",
    "save": "保存",
    "cancel": "やめる",
    "delete": "削除",
    "noMilestones": "まだマイルストーンがありません。",
    "unassigned": "マイルストーン未割当の着金 {{count}}件",
    "failed": "着金を読み書きできませんでした。"
  },
  "settlement": {
    "otherUnassignedTitle": "予算未割当の支出（立替ではないもの・{{count}}件）",
    "otherUnassignedLead": "メールで届いた請求書や CSV で取り込んだ支出のうち、まだ費目が決まっていないものです。費目を選ぶと、収益管理のその費目の実績に入ります。立替の分は上の人ごとの一覧で選べます。",
    "title": "精算",
    "lead": "立て替えた人と帯同スタッフごとに、返す額と領収書をまとめています。行を開くと領収書が見られます。",
    "statTotal": "返す額の合計",
    "statWaiting": "承認待ち",
    "statCheck": "要確認",
    "statClosed": "提出完了",
    "countValue": "{{count}}件",
    "empty": "この案件にはまだ立替も帯同費もありません。",
    "unknownTitle": "立て替えたか確認中",
    "unknownLead": "誰が払ったか・会社が返すかがまだ分からない領収書です。",
    "noName": "名前なし",
    "closed": "提出完了",
    "notClosed": "提出待ち",
    "waitingN": "承認待ち {{count}}",
    "checkN": "要確認 {{count}}",
    "breakdownAdvanced": "立替 {{amount}}（{{count}}件）",
    "breakdownFee": "帯同費 {{amount}}",
    "feeMissing": "帯同費 未入力",
    "noReceipts": "領収書はまだありません。",
    "noImage": "画像なし",
    "list": {
      "colDate": "日付",
      "colVendor": "支払先",
      "colContent": "内容",
      "colAmount": "金額",
      "colAttachment": "添付",
      "colStatus": "状態",
      "colBudget": "予算科目",
      "receipt": "領収書",
      "noAttachment": "なし",
      "needsApproval": "承認が必要なもの（{{count}}件）",
      "approved": "承認済み・自動承認（{{count}}件）",
      "rejected": "却下・対象外（{{count}}件）",
      "selectAll": "すべて選ぶ",
      "selectRow": "この明細を選ぶ",
      "selectedPrefix": "選んだ明細（{{count}}件）を",
      "bulkBudget": "まとめて割り当てる予算科目",
      "bulkBudgetPick": "予算科目を選ぶ…",
      "bulkAssign": "まとめて割り当て",
      "bulkApprove": "まとめて承認（{{count}}件）",
      "unassigned": "未割当",
      "toUnassigned": "未割当に戻す",
      "cogs": "原価",
      "opex": "販管費",
      "unknownLine": "（この案件にない科目）",
      "budgetSaveFailed": "予算科目を保存できませんでした。時間をおいてもう一度お試しください。",
      "kind": "原価か販管費か",
      "kindSaveFailed": "原価／販管費を保存できませんでした。時間をおいてもう一度お試しください。",
      "bulkApproveNone": "選んだ明細に、承認できる承認待ちがありません。"
    },
    "chip": {
      "waiting": "承認待ち",
      "check": "要確認",
      "auto": "自動承認",
      "approved": "承認済",
      "confirmed": "確定",
      "rejected": "却下",
      "excluded": "対象外"
    },
    "noTitle": "（内容なし）",
    "amountUnknown": "金額不明",
    "state": {
      "confirmed": "確定",
      "waiting": "承認待ち",
      "check": "要確認",
      "rejected": "対象外"
    },
    "approve": "承認",
    "reject": "却下",
    "approveAll": "承認待ち {{count}} 件をまとめて承認",
    "changeToReject": "却下にする",
    "changeToApprove": "承認に戻す",
    "checkFirst": "金額か読み取りを確かめてから承認できます。",
    "approvedBy": "承認 {{who}} {{date}}",
    "rejectedBy": "却下 {{who}} {{date}}",
    "decideFailed": "保存できませんでした。もう一度押してください。",
    "skip": {
      "not_found": "見つからない領収書がありました。",
      "not_admin": "承認できるのは管理者だけです。",
      "not_due": "会社が返す立替ではないものがありました。",
      "self": "自分が立て替えた分は、ほかの管理者が承認します。",
      "not_ready": "読み取りの確認が済んでいないものがありました。",
      "no_amount": "金額が分からないものは承認できません。"
    },
    "deadline": "精算の締切 {{date}}（終了 {{end}} から10営業日）",
    "feeLine": "帯同費: 日当 {{rate}}円 × {{days}}日",
    "feeNotSet": "帯同費（日当・帯同日数）がまだ入っていません。",
    "notAssigned": "この人はツアーの帯同者に入っていません。",
    "editFee": "日当・日数を入れる",
    "assignWithFee": "帯同者にして日当を入れる",
    "dailyRate": "日当（円）",
    "attendDays": "帯同日数",
    "saveFee": "保存",
    "cancel": "やめる",
    "saveFailed": "保存できませんでした。もう一度押してください。",
    "addStaffTitle": "帯同者を追加",
    "addStaffPick": "取引先から選ぶ",
    "status": {
      "confirming": "確認待ち",
      "disputed": "内容が違うと回答",
      "agreed": "内容OK・請求書待ち",
      "invoice_submitted": "請求書提出済",
      "paid": "支払済"
    },
    "invoiceMethod": {
      "generate": "請求書: こちらで作成",
      "upload": "請求書: 自分で作って送る",
      "email": "請求書: メール"
    },
    "changeFee": "日当・日数を直す",
    "wholeNumber": "日当は 0 以上の整数（9,999,999 円まで）、日数は 0.5 日刻み（366 日まで）で入れてください。マイナスは不可です。",
    "listFile": "立替経費リスト",
    "downloadAll": "立替経費リストをダウンロード（全員・CSV）",
    "downloadPerson": "この人の立替経費リスト（CSV）",
    "editReceipt": "直す",
    "noReceipt": {
      "add": "領収書なしで足す（紛失など）",
      "lead": "本人が申告した立替を、領収書なしで足します。この人が立て替えた分（会社が返す）として入り、領収書が無いので承認が必要なものに入ります。",
      "date": "支払日",
      "category": "種類",
      "what": "内容（例: とどろみグラウンド 駐車場 10/17・18）",
      "amount": "金額（円）",
      "save": "足す",
      "cancel": "やめる",
      "failed": "足せませんでした。もう一度押してください。",
      "unassigned": "足しましたが、この人の立替にできませんでした。もう一度足すと二重になるので、経費タブでその行を確かめてください。",
      "cat": {
        "transport": "交通",
        "meal": "食事",
        "accommodation": "宿泊",
        "other": "その他"
      }
    },
    "ask": {
      "button": "質問",
      "sent": "質問済み（HiAsh で返事を見る）",
      "label": "立て替えた人に HiAsh（WhatsApp）で送ります",
      "prefill": "{{about}} の領収書について確認させてください。",
      "send": "送信",
      "failed": "送れたか確認できませんでした。HiAsh ページで届いたか確かめてください。"
    },
    "remind": {
      "title": "リマインドと未提出",
      "schedule": "リマインド日: {{days}}",
      "today": "今日は {{n}} 回目のリマインド日です",
      "next": "次は {{date}}",
      "overdue": "締切を過ぎて、提出完了になっていない人が {{count}} 人います",
      "notClosed": "提出完了になっていない人: {{names}}",
      "allClosed": "帯同者は全員、提出完了です。",
      "copy": "リマインド文をコピー"
    },
    "payDay": "{{date}} 支払予定",
    "invoiceFromPage": "確認ページから届いた請求書",
    "openInvoice": "請求書を開く",
    "payDayRule": "15 日締め・当月末払い（16 日以降に受け取った請求書は翌月末）",
    "link": {
      "answeredDone": "本人が「以上です」{{date}}",
      "answeredDisputed": "本人が「違う」{{date}}",
      "disputeNote": "本人から「違う・足りないものがある」: {{note}}",
      "noNote": "（一言なし）",
      "joinLegend": "同じページに一緒に載せる",
      "flagged": "本人の旗 {{count}}",
      "flagTitle": "本人が「おかしい」と言っている明細",
      "resolve": "片づけた",
      "resolveFailed": "片づけたことを記録できませんでした。もう一度押してください。"
    },
    "copySettleLink": "「これで立替・精算は以上ですか」をコピー（確認リンクつき）",
    "settleLinkFailed": "確認リンクを作れませんでした。時間をおいてもう一度押してください。",
    "confirmMessage": "ツアー後の確認メッセージ",
    "beforeSending": "送る前に: {{what}}",
    "copyMessage": "メッセージをコピー",
    "copied": "コピーしました",
    "copyFailed": "コピーできませんでした。上の文面を選んでコピーしてください。",
    "blocker": {
      "waiting": "承認待ちが {{count}} 件あります",
      "check": "要確認が {{count}} 件あります",
      "fee": "日当・帯同日数が入っていません"
    },
    "labelOnly": "WhatsApp の名前だけで受けた {{count}} 件です。立て替えた人（取引先）を選ぶと承認できるようになります。",
    "advancer": "立て替えた人",
    "advancerPick": "立て替えた人を選ぶ",
    "markDue": "会社が返す",
    "markNone": "返さない（精算済）",
    "assignResult": "自動承認 {{auto}} 件・人が承認 {{rest}} 件になりました。",
    "autoApproved": "自動承認（ルール v{{version}}）",
    "assignSkip": {
      "not_found": "見つからない領収書がありました。",
      "not_allowed": "立替を決められるのは管理者と PM だけです。",
      "decided": "承認・却下済みのものは変えていません。",
      "partner_not_found": "選んだ取引先が見つかりません。"
    },
    "rulesTitle": "自動承認のルール",
    "rulesLine": "税込 {{limit}} 円以下・{{categories}}・ツアー期間の前後 {{margin}} 日以内なら自動承認（ルール v{{version}}）。それ以外は管理者が承認します。",
    "notifyTitle": "承認待ちのお知らせ（Accounting Bot）",
    "notifyNoSlack": "Slack がつながっていません。設定 → Slack でつなぐと選べます。",
    "notifyOff": "通知しない",
    "notifyNeedsInvite": "（Bot の招待が必要）",
    "notifySaved": "保存しました。",
    "notifyAdminOnly": "保存できませんでした（変えられるのは管理者だけです）。",
    "notifyLead": "承認はこの精算タブの「承認が必要なもの」で行います。送り先を選ぶと、平日の朝 9 時に「承認待ちの経費が N 件」をツアーごとの件数とこの画面へのリンクつきで送ります（0 件の日は送りません）。",
    "statusLabel": "精算の状態",
    "statusNone": "確認前",
    "invoiceMethodLabel": "請求書の出し方",
    "invoiceMethodNone": "請求書の出し方: 未定",
    "receiptsClosedLabel": "領収書の提出完了",
    "statusSaveFailed": "保存できませんでした（変えられるのは管理者だけです）。",
    "saveStatus": "状態を保存",
    "days": {
      "needTitle": "承認が必要なもの: 帯同日数（本人申告）",
      "approvedTitle": "帯同日数（本人申告）・承認済み",
      "line": "{{days}}日",
      "half": "（半日）",
      "approve": "日数を承認",
      "approveFailed": "承認できませんでした。読み直してから、もう一度押してください。",
      "confirmTitle": "和也さんへの帯同日数の確認",
      "confirmLead": "帯同者全員の請求書がそろいました。コピーして和也さんに送り、OK なら人ごとに日数を承認してください。違っていたら、その人に請求書を直してもらいます。",
      "copy": "確認文をコピー",
      "copied": "コピーしました"
    },
    "feeRateOnly": "日当 {{rate}}円（帯同した日は、ツアーのあと本人に聞きます）",
    "invoiceEmail": {
      "title": "請求書の受け取り用メールアドレス",
      "lead": "帯同者が確認ページで「メールで送る」を選んだときの送り先です。空のときは「メールで送る」を出しません。",
      "failed": "保存できませんでした。メールアドレスの形を確かめてください（管理者だけが変えられます）。",
      "save": "送り先を保存"
    },
    "lock": {
      "agreedTitle": "本人が総額に OK 済み（{{date}}）",
      "billedTitleUndated": "請求書を受け取り済み",
      "billedTitle": "請求書を受け取り済み（{{date}}）",
      "total": "総額 {{amount}}",
      "lead": "日当・日数・総額は変えられません。直すときは、理由をつけて取り消し、本人に出し直してもらいます（取り消しも記録に残ります）。",
      "reopen": "取り消して出し直す",
      "reason": "取り消す理由",
      "reasonPlaceholder": "例: 日当の入力ミス",
      "confirm": "理由をつけて取り消す",
      "cancel": "やめる",
      "failed": "取り消せませんでした。もう一度押してください。",
      "paid": "支払済みなので取り消せません。"
    }
  },
  "hiash": {
    "title": "HiAsh（WhatsApp）",
    "lead": "スタッフと HiAsh（WhatsApp の Tour Desk）のやり取りを人ごとに見て、ここから返信もできます（HiAsh の番号から送ります）。WhatsApp で届いた領収書には、この案件の立替の行が付きます。",
    "reload": "読み直す",
    "loading": "読み込んでいます…",
    "people": "スタッフ",
    "pick": "左から人を選ぶと、やり取りが出ます。",
    "noStaff": "スタッフのグループにまだ誰もいません。",
    "noMessages": "まだやり取りはありません",
    "desk": "HiAsh",
    "photo": "写真",
    "file": "ファイル",
    "other": "（スタンプなど）",
    "back": "一覧に戻る",
    "receipt": "この案件の立替 {{amount}} → 精算",
    "amountUnknown": "金額不明",
    "error": {
      "forbidden": "このページは管理者だけが見られます。",
      "not_configured": "HiAsh との接続がまだ設定されていません。",
      "unavailable": "WhatsApp のやり取りを読み込めませんでした。少しおいて「読み直す」を押してください。"
    },
    "fromCamp": "Camp から（{{who}}）",
    "replyLabel": "{{name}} さんに WhatsApp で返信",
    "replyNote": "HiAsh の番号から、この人にだけ送ります。",
    "send": "送信",
    "sending": "送信中…",
    "sendUnknown": "送れたか確認できませんでした。やり取りを読み直して、届いていなければもう一度送ってください。",
    "openTitle": "要対応 {{count}} 件",
    "openLead": "Bot が答えないスタッフのメッセージです（金額の訂正・領収書の紛失・質問など）。判断して返信するか、精算タブで直してから「対応済み」にしてください。返信だけでは消えません。",
    "openThread": "やり取りを開く",
    "markHandled": "対応済み",
    "markFailed": "対応済みにできませんでした。もう一度押してください。",
    "needsReply": "要対応",
    "needsReplyCount": "要対応 {{count}}",
    "handledBy": "対応済み（{{who}}）",
    "fixInSettlement": "精算タブで直す"
  }
}
